<!-- 调拨单编辑页面第二版 -->
<template>
    <div class="saleorder-v3" v-loading="searchApParams._visible" element-loading-spinner="none">
        <div class="bread-nav">
            <el-button size="small" icon="el-icon-back" class="search-btn btn-primary" @click="goback()" v-if="type != 1"></el-button>
            <el-button size="small" class="search-btn btn-primary" @click="showSearch()" tabindex="-1" v-if="type != 1">搜索配件(F2)</el-button>
            <el-button size="small" class="search-btn btn-primary" @click="showAPMsgDialog()" tabindex="-1" v-if="type != 1">查看配件信息(F3)</el-button>
            <el-button title="调出历史" size="small" v-if="type != 1&&submitData.OutWarehouseId" @click.stop="showTOutHisDialog()" class="search-btn btn-primary">调出历史(F4) </el-button>
            <el-button title="调入历史" size="small" v-if="type != 1&&submitData.InWarehouseId" @click.stop="showTInHisDialog()" class="search-btn btn-primary">调入历史(F5) </el-button>
            <el-button title="销售历史" size="small" v-if="type != 1&&submitData.InWarehouseId" @click.stop="showSaleHisDialog()" class="search-btn btn-primary">销售历史(F6) </el-button>
            <el-button size="small" class="search-btn btn-primary" @click.stop="save()" v-if="type == 2 || type == 3 || type == 4" :disabled="saving">保存调仓单(F11)</el-button>
            <el-button size="small" class="search-btn btn-primary" @click.stop="saveAndAdd()" v-if="type == 2 || type == 3" :disabled="saving">保存并继续新增(F12)</el-button>
            <breadcrumb :canBackHistory="true" :pageTitle="pageTitle" v-if="type == 1"></breadcrumb>
        </div>
        <div :class="showOrderMsg ? 'section-title' : 'section-title section-magin'">
            <div>
                <span>调拨单信息 {{ submitData.TOCode ? '【' + submitData.TOCode + '】' : '' }}</span>
                <span>【 调拨总数：{{ allNum }} &nbsp;&nbsp; 调拨总额：{{ allMoney }} 】</span>
            </div>
            <div class="img-e-op" @click="showMsg" v-show="!showOrderMsg">
                <img src="../../../assets/images/down-e.png" />
            </div>
            <div class="img-e-op" @click="hideMsg" v-show="showOrderMsg">
                <img src="../../../assets/images/up-e.png" />
            </div>
        </div>
        <div class="order-infoes" v-show="showOrderMsg">
            <el-form :model="submitData" ref="formMsg" label-width="90px" style="width: 100%; padding-right: 10px; padding-left: 10px" :rules="rules">
                <el-row :gutter="20">
                    <el-col :span="5">
                        <div class="grid-content bg-purple">
                            <el-form-item label="调出仓库" prop="OutWarehouseId">
                                <el-input v-if="dataReadonly || type != 3" disabled size="small" v-model="submitData.OutWarehouseName"></el-input>
                                <el-select v-model="submitData.OutWarehouseId" style="width: 100%" size="small" v-else filterable clearable @change="OutWarehouseChange">
                                    <el-option v-for="optionItem in WarehouseList" :key="optionItem.WarehouseId" :label="optionItem.WarehouseName" :value="optionItem.WarehouseId">
                                        <span style="float: left">{{ optionItem.WarehouseName }}</span>
                                        <span v-if="optionItem.Type == 1" style="float: right; color: #8492a6; font-size: 13px">（前置仓）</span>
                                    </el-option>
                                </el-select>
                            </el-form-item>
                        </div>
                    </el-col>
                    <el-col :span="3">
                        <div class="grid-content bg-purple">
                            <el-form-item label="调出成本" prop="TranCost">
                                <el-input-number
                                    type="number"
                                    class="search-item"
                                    style="width: 100%"
                                    :min="0"
                                    :precision="2"
                                    controls-position="right"
                                    size="small"
                                    v-model="submitData.TranCost"
                                    :disabled="dataReadonly || type != 3"
                                ></el-input-number>
                            </el-form-item>
                        </div>
                    </el-col>
                    <el-col :span="5" v-if="!(dataReadonly || type != 3)">
                        <div class="grid-content bg-purple">
                            <el-form-item label="分摊成本" prop="calcType">
                                <el-select :class="['search-item w60', { w100: calcType != 2 }]" v-model="calcType" size="small" v-if="!(dataReadonly || type != 3)">
                                    <el-option v-for="item in calcTypeList" :key="item.Value" :label="item.Text" :value="item.Value"></el-option>
                                </el-select>
                                <el-input-number
                                    type="number"
                                    style="width: 40%"
                                    class="search-item"
                                    :min="0"
                                    :precision="2"
                                    controls-position="right"
                                    size="small"
                                    v-model="point"
                                    :step="0.1"
                                    v-if="calcType == 2"
                                ></el-input-number>
                            </el-form-item>
                        </div>
                    </el-col>
                    <el-col :span="6" v-if="!(dataReadonly || type != 3)">
                        <div class="discount-zone">
                            <el-button size="small" class="search-btn btn-primary" @click="calcShare()" v-if="isCalcFirst && !(dataReadonly || type != 3)">计算分摊</el-button>
                            <el-button size="small" class="search-btn" type="warning" @click="recoverCalc()" v-if="!isCalcFirst && !(dataReadonly || type != 3)"
                                >恢复计算前</el-button
                            >
                            <div class="search-name" style="color: red; margin: 0">（※成本价计算分摊后一旦保存，将无法再恢复到原有的成本价，但不影响商品数据！）</div>
                        </div>
                    </el-col>
                </el-row>
                <el-row :gutter="20">
                    <el-col :span="5">
                        <div class="grid-content bg-purple">
                            <el-form-item label="调入仓库" prop="InWarehouseId">
                                <el-input v-if="dataReadonly || type != 3" disabled size="small" v-model="submitData.InWarehouseName"></el-input>
                                <el-select
                                    v-model="submitData.InWarehouseId"
                                    style="width: 100%"
                                    v-else
                                    class="search-item"
                                    size="small"
                                    filterable
                                    clearable
                                    @change="InWarehouseChange"
                                >
                                    <el-option
                                        v-for="optionItem in WarehouseNotAuthList"
                                        :key="optionItem.WarehouseId"
                                        :label="optionItem.WarehouseName"
                                        :value="optionItem.WarehouseId"
                                    >
                                        <span style="float: left">{{ optionItem.WarehouseName }}</span>
                                        <span v-if="optionItem.Type == 1" style="float: right; color: #8492a6; font-size: 13px">（前置仓）</span>
                                    </el-option>
                                </el-select>
                            </el-form-item>
                        </div>
                    </el-col>
                    <el-col :span="10">
                        <div class="grid-content bg-purple">
                            <el-form-item label="调仓备注" prop="Remark">
                                <el-input class="search-item" size="small" v-model="submitData.Remark" :disabled="dataReadonly"></el-input>
                            </el-form-item>
                        </div>
                    </el-col>
                </el-row>
            </el-form>
        </div>
        <div :class="showResultMsg ? 'section-title' : 'section-title section-magin'" @click="hideMsg" v-if="type != 1">
            <div>
                <span>搜索配件结果</span>
                <span style="margin-left: 10px; font-size: 14px">{{ tableDataLength > 0 ? '(结果数：' + tableDataLength + ')' : '' }} </span>
                <el-link style="width: 120px" v-show="tableDataLength > 0" type="primary" @click="chooseAllAPsHandle">全部加入订单明细</el-link>
            </div>
            <div class="flex">
                <el-button v-if="isCanTBSet" icon="el-icon-setting" type="primary" class="search-set-btn" @click="showTableSetDialog()"></el-button>
                <div class="img-e-op" @click="showResultFunc" v-show="!showResultMsg">
                    <img src="../../../assets/images/down-e.png" />
                </div>
                <div class="img-e-op" @click="hideResultFunc" v-show="showResultMsg">
                    <img src="../../../assets/images/up-e.png" />
                </div>
            </div>
        </div>
        <div @click="hideMsg" v-show="showResultMsg" class="search-in-order" style="margin-bottom: 5px" v-if="type != 1">
            <ux-grid
                ref="multipleTable"
                border=""
                height="336px"
                style="width: 100%"
                @cell-dblclick="dblChooseAps"
                highlight-current-row
                @table-body-scroll="tableLoad"
                v-loading="searchData.page == 1 ? searchLoading : false"
                show-overflow
                :data="tableData"
                :row-class-name="tableRowClassName"
                @row-click="rowClick"
                @sort-change="sortChange"
            >
                <template v-for="(item,index) in columnShowSets">
                    <ux-table-column
                        v-bind:key="item.ColumnCode + index"
                        :field="item.ColumnCode"
                        :width="item.Width > 0 ? item.Width + 'px' : '150px'"
                        :title="item.ColumnName"
                        resizable
                        :sortable="item.IsSort"
                        :remote-sort="item.IsSort"
                        header-align
                        :prop="item.ColumnCode"
                        v-if="item.IsShow && item.ColumnCode == 'POrderWaitInQuantity'"
                    >
                        <template v-slot="{ row }">
                            <el-button v-if="row.LoadSpaceInvent" icon="el-icon-loading" type="text"></el-button>
                            <span v-else>
                                <el-button @click="showNeedInData(row)" type="text" style="padding: 0px" v-if="row.POrderWaitInQuantity > 0">{{
                                    row.POrderWaitInQuantity
                                }}</el-button>
                                <span v-else>{{ row.POrderWaitInQuantity }}</span>
                            </span>
                        </template>
                    </ux-table-column>
                    <ux-table-column
                        v-bind:key="item.ColumnCode + index"
                        :field="item.ColumnCode"
                        :width="item.Width > 0 ? item.Width + 'px' : '150px'"
                        :title="item.ColumnName"
                        resizable
                        :sortable="item.IsSort"
                        :remote-sort="item.IsSort"
                        header-align
                        :prop="item.ColumnCode"
                        v-else-if="item.IsShow && item.ColumnCode == 'OrderWaitOutQuantity'"
                    >
                        <template v-slot="{ row }">
                            <el-button v-if="row.LoadSpaceInvent" icon="el-icon-loading" type="text"></el-button>
                            <span v-else>
                                <el-button @click="showNeedOutData(row)" type="text" style="padding: 0px" v-if="row.OrderWaitOutQuantity > 0">{{
                                    row.OrderWaitOutQuantity
                                }}</el-button>
                                <span v-else>{{ row.OrderWaitOutQuantity }}</span>
                            </span>
                        </template>
                    </ux-table-column>
                    <ux-table-column
                        v-bind:key="item.ColumnCode + index"
                        :field="item.ColumnCode"
                        :width="item.Width > 0 ? item.Width + 'px' : '150px'"
                        :title="item.ColumnName"
                        resizable
                        :sortable="item.IsSort"
                        :remote-sort="item.IsSort"
                        header-align
                        :prop="item.ColumnCode"
                        v-else-if="item.IsShow && item.ColumnCode == 'PlanPurchase'"
                    >
                        <template v-slot="{ row }">
                            <el-button v-if="row.LoadSpaceInvent" icon="el-icon-loading" type="text"></el-button>
                            <span v-else>{{ row.PlanPurchase }}</span>
                        </template>
                    </ux-table-column>
                    <ux-table-column
                        v-bind:key="item.ColumnCode + index"
                        :field="item.ColumnCode"
                        :width="item.Width > 0 ? item.Width + 'px' : '150px'"
                        :title="item.ColumnName"
                        resizable
                        :sortable="item.IsSort"
                        :remote-sort="item.IsSort"
                        header-align
                        :prop="item.ColumnCode"
                        v-else-if="item.IsShow && item.ColumnCode == 'APCode'"
                    >
                        <template v-slot="{ row }">
                            <el-button v-if="row.MainImage" style="padding: 0" icon="el-icon-picture" type="text"></el-button>
                            <i v-if="row.IsSelected" class="out-active">{{ row.APCode }} </i>
                            <i v-else>{{ row.APCode }}</i>
                        </template>
                    </ux-table-column>
                    <ux-table-column
                        v-bind:key="item.ColumnCode + index"
                        :field="item.ColumnCode"
                        :width="item.Width > 0 ? item.Width + 'px' : '150px'"
                        :title="item.ColumnName"
                        resizable
                        :sortable="item.IsSort"
                        :remote-sort="item.IsSort"
                        header-align
                        :prop="item.ColumnCode"
                        v-else-if="item.IsShow"
                    >
                        <template slot-scope="scope">
                            <i>{{ scope.row[item.ColumnCode] }} </i>
                        </template>
                    </ux-table-column>
                </template>
            </ux-grid>
            <div class="invens-summary" v-if="isShowSummary">
                <span class="title">各仓库库存数据：</span>
                <div v-for="item in summaryList" :key="item.Name" class="summary-item">
                    <span class="sname">【 {{ item.Name }} 】</span>
                    <span class="sname">库存数：</span>
                    <span class="scount"> {{ item.Count }} </span>
                </div>
            </div>
        </div>
        <div class="section-title" @click="hideMsg()">
            <div>调拨商品明细</div>
        </div>
        <div id="infinite-list" @click="hideMsg()" class="sales-order-edit">
            <ux-grid
                ref="infiniteTable"
                :data="dataList"
                keep-source
                :height="type != 1 ? '314px' : '600px'"
                :highlight-current-row="false"
                :edit-config="{ trigger: 'click', mode: 'row' }"
                :row-style="setRowStyle"
                row-id="rowkey"
                empty-text="暂无数据"
            >
                <ux-table-column class-name="table-sort" type="index" title="序号" width="65" resizable></ux-table-column>
                <ux-table-column field="APCode" title="汽配编码" resizable>
                    <template v-slot:header="{ column }">
                        <div class="head-view">
                            <span class="color-red">*</span>
                            {{ column.title }}
                            <span class="sort-view">
                                <i :class="['el-icon-caret-top', { active: sortActive === 'top' }]" title="升序,从小到大排序" @click="changeTableSort('top', 'APCode')"></i>
                                <i
                                    :class="['el-icon-caret-bottom', { active: sortActive === 'bottom' }]"
                                    title="降序,从大到小排序"
                                    @click="changeTableSort('bottom', 'APCode')"
                                ></i>
                            </span>
                        </div>
                    </template>
                    <template v-slot="{ row, rowIndex }">
                        <div class="sales-apcode div-padding-12">
                            <span class="sp-i" v-show="row.APCode">
                                <i title="配件信息" class="el-icon-info" @click.stop="showAPMsgDialog(row.EntpTempGoodsId)"></i>
                            </span>
                            <span>{{ row.APCode }}</span>
                            <el-tag v-if="row.State == 1" class="tag" type="warning">已删除</el-tag>
                        </div>
                    </template>
                </ux-table-column>
                <ux-table-column field="GoodName" title="配件名称" resizable>
                    <template v-slot:header="{ column }">
                        <span class="color-red">*</span>
                        {{ column.title }}
                    </template>
                    <template v-slot="{ row, rowIndex }">
                        <div class="div-padding-12">
                            {{ row.GoodName }}
                        </div>
                    </template>
                </ux-table-column>
                <ux-table-column field="AutoSerise" title="车型" resizable>
                    <template v-slot:header="{ column }">
                        <span class="color-red">*</span>
                        {{ column.title }}
                    </template>
                    <template v-slot="{ row, rowIndex }">
                        <el-tooltip effect="dark" :content="row.AutoSerise ? row.AutoSerise.toString() : ''" :disabled="!row.AutoSerise" placement="top">
                            <div class="div-padding-12">
                                {{ row.AutoSerise }}
                            </div>
                        </el-tooltip>
                    </template>
                </ux-table-column>
                <ux-table-column field="Cate" title="分类" width="80" resizable key="Cate">
                    <template v-slot="{ row }">
                        <div class="div-padding-12">{{ row.Cate }}</div>
                    </template>
                </ux-table-column>
                <ux-table-column field="Brand" title="品牌" width="80" resizable key="Brand">
                    <template v-slot="{ row }">
                        <div class="div-padding-12">{{ row.Brand }}</div>
                    </template>
                </ux-table-column>
                <ux-table-column field="Origin" title="产地" width="80" key="origin" resizable v-if="!funcConfig">
                    <template v-slot="{ row }">
                        <div class="div-padding-12">{{ row.Origin }}</div>
                    </template>
                </ux-table-column>
                <ux-table-column field="Unit" title="单位" width="70" resizable key="Unit">
                    <template v-slot="{ row }">
                        <div class="div-padding-12">{{ row.Unit }}</div>
                    </template>
                </ux-table-column>

                <ux-table-column field="OriginalCount" title="当前在库数" width="100" key="14">
                    <template v-slot="{ row }">
                        <div class="div-padding-12">{{ row.OriginalCount }}</div>
                    </template>
                </ux-table-column>
                <ux-table-column field="Remain" v-if="isShowRemain && (type == 2 || type == 4)" title="留余" width="70" key="15">
                    <template v-slot="{ row }">
                        <div class="div-padding-12 out-active"> {{ row.StorageInventory + (isAddWaitIn ? row.POrderWaitInQuantity : 0) - row.OrderWaitOutQuantity }}</div>
                    </template>
                </ux-table-column>

                <ux-table-column field="Count" title="调出数量" width="100" key="5" :edit-render="{ autofocus: '.el-input__inner' }">
                    <template v-slot="{ row }">
                        <div class="div-padding-12">{{ row.Count }}</div>
                    </template>
                    <template v-slot:edit="scope">
                        <div class="sales-input-cell">
                            <el-input-number
                                ref="countRef"
                                size="small"
                                type="number"
                                :min="scope.row.WarehousedOutCount == 0?1:scope.row.WarehousedOutCount"
                                :max="scope.row.OriginalCount"
                                v-model="scope.row.Count"
                                @change="priceChange"
                                :disabled="type == 1"
                                @keyup.right.native="keyEvent($event, 'Count', scope.row, scope.rowIndex)"
                                @focus="selectAutoHandle('countRef')"
                            ></el-input-number>
                        </div>
                    </template>
                </ux-table-column>
                <ux-table-column v-if="type == 1 || type == 4" field="WarehousedOutCount" title="已出库数" width="100" key="14">
                    <template v-slot="{ row }">
                        <div class="div-padding-12">{{ row.WarehousedOutCount }}</div>
                    </template>
                </ux-table-column>
                <ux-table-column v-if="type == 1" field="WarehousedCount" title="实际入库数" width="100" key="14">
                    <template v-slot="{ row }">
                        <div class="div-padding-12">{{ row.WarehousedCount }}</div>
                    </template>
                </ux-table-column>
                <ux-table-column field="CostPrice" title="成本价" width="100" key="costprice" :edit-render="{ autofocus: '.el-input__inner' }">
                    <template v-slot="{ row }">
                        <div :class="['div-padding-12', { 'special-border': !row.CostPrice || row.CostPrice === 0 }]">
                            {{ row.CostPrice }}
                        </div>
                    </template>
                    <template v-slot:edit="scope">
                        <div class="salecounts-input-cell">
                            <el-input-number
                                type="number"
                                size="small"
                                ref="priceRef"
                                v-model="scope.row.CostPrice"
                                @input="priceChange"
                                placeholder="成本价"
                                :disabled="type == 1"
                                @keyup.left.native="keyEvent($event, 'CostPrice', scope.row, scope.rowIndex)"
                                @focus="selectAutoHandle('priceRef')"
                            ></el-input-number>
                        </div>
                    </template>
                </ux-table-column>
                <ux-table-column field="dcze" title="调出总额" width="120" resizable>
                    <template v-slot="{ row }">
                        <div class="div-padding-12">{{ ((row.Count?row.Count:0 )* (row.CostPrice?row.CostPrice:0)).toFixed(2) }}</div>
                    </template>
                </ux-table-column>
                <ux-table-column title="调出仓位" width="100" key="outspace" v-if="type == 1">
                    <template v-slot="{ row }">
                        <div class="div-padding-12">
                            <span>
                                {{ row.OutSpaceList && row.OutSpaceList.length > 0 ? row.OutSpaceList[0] : '未出仓' }}
                                <el-tooltip placement="right">
                                    <div slot="content" v-html="$options.filters.SpaceTextSplit(row.OutSpaceList)"></div>
                                    <img
                                        src="@/assets/images/more.png"
                                        style="width: 22px; height: 22px; margin-left: 4px"
                                        v-if="row.OutSpaceList && row.OutSpaceList.length > 1"
                                    />
                                </el-tooltip>
                            </span>
                        </div>
                    </template>
                </ux-table-column>
                <ux-table-column title="调入仓位" width="100" key="inspace" v-if="type == 1">
                    <template v-slot="{ row }">
                        <div class="div-padding-12">
                            <span>
                                {{ row.InSpaceList && row.InSpaceList.length > 0 ? row.InSpaceList[0] : '未入仓' }}
                                <el-tooltip placement="right">
                                    <div slot="content" v-html="$options.filters.SpaceTextSplit(row.OutSpaceList)"></div>
                                    <img
                                        src="@/assets/images/more.png"
                                        style="width: 22px; height: 22px; margin-left: 4px"
                                        v-if="row.InSpaceList && row.InSpaceList.length > 1"
                                    />
                                </el-tooltip>
                            </span>
                        </div>
                    </template>
                </ux-table-column>
                <ux-table-column title="操作" width="70" key="11" v-if="!dataReadonly">
                    <template v-slot="{ row, rowIndex }">
                        <div class="operate" v-if="!dataReadonly">
                            <el-button size="small" v-if="!row.WarehousedOutCount || row.WarehousedOutCount == 0" @click="delItem(rowIndex)" icon="el-icon-delete"></el-button>
                        </div>
                    </template>
                </ux-table-column>
            </ux-grid>
        </div>
        <!--   配件信息     -->
        <el-dialog :close-on-click-modal="false" title="配件信息" :visible.sync="APMsgVisible" width="1000px">
            <div v-if="APMsgVisible">
                <APMsg :dialogFormVisible="APMsgVisible" :EntpTempGoodsId="EntpTempGoodsIdEdit" @closeDialog="closeAPMsgDialog"></APMsg>
            </div>
        </el-dialog>
        <el-dialog :close-on-click-modal="false" title="自定义列展示设置" @close="closeTableSetDialog" :visible.sync="tableSetsVisible" append-to-body width="600px">
            <div class="dialog-content" v-if="tableSetsVisible">
                <tableSets :tableCode="tableCode" @closeDialog="closeTableSetDialog"></tableSets>
            </div>
        </el-dialog>
        <el-dialog
            :close-on-click-modal="false"
            title="配件搜索"
            :visible.sync="searchVisible"
            width="400px"
            append-to-body
            v-dialog-drag
            lock-scroll
            :modal="false"
            id="search-dc-dialog"
            custom-class="search-item-dialog"
            style="margin-left: -170px"
            @close="closeSearchDialog"
        >
            <div class="dialog-content" v-if="searchVisible">
                <el-form ref="form" label-position="left" label-width="82px">
                    <el-form-item label="联合搜索">
                        <el-input
                            ref="search_0"
                            class="search-item"
                            style="width: 100%"
                            size="small"
                            clearable
                            v-model="searchData.JointSearch"
                            :placeholder="'用分隔符“' + (separator == ' ' ? '空格' : separator) + '”隔开'"
                            @focus="selectAutoHandle('search_0')"
                        ></el-input>
                    </el-form-item>
                    <el-form-item label="配件编码">
                        <el-input
                            ref="search_1"
                            class="search-item"
                            style="width: 100%"
                            size="small"
                            v-model="searchData.APCode"
                            placeholder="请输入配件编码"
                            @focus="selectAutoHandle('search_1')"
                        ></el-input>
                    </el-form-item>
                    <el-form-item label="配件名称">
                        <el-autocomplete
                            ref="search_2"
                            size="small"
                            style="width: 100%"
                            v-model="searchData.GoodName"
                            :fetch-suggestions="searchGoodName"
                            :debounce="500"
                            placeholder="请输入配件名称"
                            :trigger-on-focus="false"
                            @select="stopSearch"
                            v-scrollLoad="searchGoodNameLoad"
                        ></el-autocomplete>
                    </el-form-item>
                    <el-form-item label="适用车型">
                        <el-autocomplete
                            ref="search_3"
                            size="small"
                            style="width: 100%"
                            :debounce="500"
                            v-model="searchData.AutoSerise"
                            :fetch-suggestions="searchAutoSerise"
                            placeholder="请输入车型"
                            :trigger-on-focus="false"
                            @select="stopSearch"
                            v-scrollLoad="searchAutoSeriseLoad"
                        ></el-autocomplete>
                    </el-form-item>
                    <el-form-item label="精准车型" v-if="autoSeriesModel && autoSeriesModel.AutoSeriesId">
                        <el-tag closable style="width: 233px" @close="closeAutoSeries">
                            {{ autoSeriesModel.AutoSeries }}
                        </el-tag>
                        <el-checkbox v-model="isUseAS" style="margin-left: 10px"></el-checkbox>
                    </el-form-item>
                    <el-form-item label="互换码">
                        <el-input
                            ref="search_4"
                            style="width: 100%"
                            size="small"
                            v-model="searchData.GoodCode"
                            placeholder="请输入互换码"
                            @focus="selectAutoHandle('search_4')"
                        ></el-input>
                    </el-form-item>
                    <el-form-item label="汽配分类">
                        <el-select
                            ref="search_5"
                            size="small"
                            style="width: 100%"
                            v-model="searchData.Cate"
                            multiple
                            collapse-tags
                            filterable
                            clearable
                            @visible-change="getGoodsType($event)"
                        >
                            <el-option v-for="optionItem in typeList" :key="optionItem.Value" :label="optionItem.Text" :value="optionItem.Value">
                                <div class="option-content">
                                    <div>{{ optionItem.Text }}</div>
                                </div>
                            </el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item label="汽配品牌">
                        <el-select
                            ref="search_6"
                            v-model="searchData.BrandName"
                            multiple
                            collapse-tags
                            filterable
                            clearable
                            size="small"
                            style="width: 100%"
                            @visible-change="getGoodsBrand($event)"
                        >
                            <el-option :key="item.Text" v-for="item in brandList" :label="item.Text" :value="item.Text"></el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item label="库存数">
                        <div class="flex">
                            <el-select size="small" class="search-item" style="width: 90px" v-model="searchData.Symbol" clearable placeholder="符号">
                                <el-option key=">=" label=">=" value=">="></el-option>
                                <el-option key=">" label=">" value=">"></el-option>
                                <el-option key="<=" label="<=" value="<="></el-option>
                                <el-option key="<" label="<" value="<"></el-option>
                                <el-option key="=" label="=" value="="></el-option>
                                <el-option key="!=" label="!=" value="!="></el-option>
                                <el-option key="between" label="区间" value="between"></el-option>
                            </el-select>
                            <el-input
                                ref="search_7"
                                class="search-item"
                                size="small"
                                style="width: 90px"
                                v-model.trim="searchData.Invent1"
                                @focus="selectAutoHandle('search_7')"
                            ></el-input>
                            <el-input class="search-item" size="small" style="width: 90px" v-model.trim="searchData.Invent2" v-if="searchData.Symbol == 'between'"></el-input>
                        </div>
                    </el-form-item>
                    <el-form-item label="尺寸">
                        <el-input
                            ref="search_8"
                            class="search-item"
                            style="width: 100%"
                            size="small"
                            v-model="searchData.Size"
                            placeholder="请输入尺寸"
                            @focus="selectAutoHandle('search_8')"
                        ></el-input>
                    </el-form-item>
                    <el-form-item label="产地">
                        <el-input
                            ref="search_9"
                            class="search-item"
                            style="width: 100%"
                            size="small"
                            v-model="searchData.Origin"
                            placeholder="请输入产地信息"
                            @focus="selectAutoHandle('search_9')"
                        ></el-input>
                    </el-form-item>
                    <el-form-item label="自定义属性">
                        <el-input
                            ref="search_10"
                            class="search-item"
                            style="width: 100%"
                            size="small"
                            v-model="searchData.GoodDesc"
                            placeholder="请输入属性值"
                            @focus="selectAutoHandle('search_10')"
                        ></el-input>
                    </el-form-item>
                    <el-form-item label="查询公式">
                        <el-radio-group v-model="searchData.SearchType">
                            <el-radio :label="0">左等</el-radio>
                            <el-radio :label="1">全等</el-radio>
                            <el-radio :label="2">包含</el-radio>
                        </el-radio-group>
                    </el-form-item>
                </el-form>
                <div class="dialog-footer">
                    <el-button size="small" type="primary" @click="jointSets">设置查询条件</el-button>
                    <el-button size="small" @click="resetSearch">重置</el-button>
                    <el-button class="btn-primary" size="small" @click="handleSearch">查询（Enter）</el-button>
                </div>
            </div>
        </el-dialog>
        <el-dialog
            :close-on-click-modal="false"
            title="加入清单"
            width="400px"
            :visible.sync="rowVisible"
            append-to-body
            v-dialog-drag
            lock-scroll
            :modal="false"
            id="comfirm-ap-dialog"
            custom-class="search-item-dialog"
            style="margin-left: -170px"
        >
            <div class="dialog-content" v-if="rowVisible" v-loading="rowFormLoading">
                <el-form label-position="left" label-width="70px" :model="rowForm">
                    <el-form-item label="汽配编码">
                        <el-input v-model="rowForm.APCode" disabled size="small" />
                    </el-form-item>
                    <el-form-item label="配件名称">
                        <el-input v-model="rowForm.GoodName" disabled size="small" />
                    </el-form-item>
                    <el-form-item label="车型">
                        <el-input v-model="rowForm.AutoSerise" disabled size="small" />
                    </el-form-item>
                    <el-form-item label="调出数量">
                        <el-input
                            :min="1"
                            :max="rowForm.StorageInventory"
                            @input="change($event)"
                            ref="confirm_0"
                            key="confirm_0"
                            v-model="rowForm._count"
                            size="small"
                            style="width: 100%"
                            @focus="selectAutoHandle('confirm_0')"
                            type="number"
                        />
                    </el-form-item>
                    <el-form-item label="价格">
                        <el-input
                            :min="0"
                            @input="change($event, 1)"
                            ref="confirm_1"
                            v-model="rowForm._price"
                            size="small"
                            style="width: 100%"
                            @focus="selectAutoHandle('confirm_1')"
                            type="number"
                        />
                    </el-form-item>
                </el-form>
            </div>
            <div class="dialog-footer">
                <el-button class="btn-primary" size="small" @click="rowConfirm">加入清单(Enter)</el-button>
                <el-button size="small" @click="rowClose">取消(ESC)</el-button>
            </div>
        </el-dialog>
        <el-dialog :close-on-click-modal="false" title="自定义搜索条件展示设置" @close="closeJointDialog" :visible.sync="jointSetVisible" append-to-body width="400px">
            <div class="dialog-content" v-if="jointSetVisible">
                <jointSets @closeDialog="closeJointDialog"></jointSets>
            </div>
        </el-dialog>
        <el-dialog
            :title="NeedOTitle"
            :close-on-click-modal="false"
            :visible.sync="needOutDataVisible"
            append-to-body
            v-dialog-drag
            lock-scroll
            :modal="false"
            id="change-dialog"
            style="margin-left: -500px"
            width="900px"
        >
            <div v-if="needOutDataVisible">
                <APNeedOutDatas ref="APNeedOutDatas" :EntpTempGoodsId="EntpTempGoodsId" @closeDialog="needOutDataVisible = false"></APNeedOutDatas>
            </div>
        </el-dialog>
        <el-dialog
            :title="NeedITitle"
            :close-on-click-modal="false"
            :visible.sync="needInDataVisible"
            append-to-body
            v-dialog-drag
            lock-scroll
            :modal="false"
            id="change-dialog"
            style="margin-left: -500px"
            width="900px"
        >
            <div v-if="needInDataVisible">
                <APNeedInDatas ref="APNeedInDatas" :EntpTempGoodsId="EntpTempGoodsId" @closeDialog="needInDataVisible = false"></APNeedInDatas>
            </div>
        </el-dialog>
        <el-dialog
            :close-on-click-modal="false"
            title="配件在订数据"
            :visible.sync="inqHistoryVisible"
            append-to-body
            v-dialog-drag
            lock-scroll
            :modal="false"
            id="change-dialog"
            style="margin-left: -500px"
            width="900px"
        >
            <div v-if="inqHistoryVisible">
                <APInquiryHistory
                    ref="APInquiryHistory"
                    :EntpTempGoodsId="hisGoodsId"
                    :Source="1"
                    @closeDialog="
                        () => {
                            inqHistoryVisible = false;
                        }
                    "
                ></APInquiryHistory>
            </div>
        </el-dialog>
        <el-dialog
            :close-on-click-modal="false"
            title="主图"
            width="150px"
            :visible.sync="imageVisible && currentRow.MainImage !== ''"
            v-dialog-drag
            append-to-body
            lock-scroll
            :modal="false"
            id="ap-image-dialog"
            custom-class="image-item-dialog"
        >
            <div style="padding-top: 5px" v-if="imageVisible && currentRow.MainImage">
                <el-image
                    style="width: 100px; height: 100px"
                    :src="downloadUrl + currentRow.MainImage + '?imageView2/2/w/100'"
                    @click="getGoodsImages()"
                    fit="contain"
                    lazy
                ></el-image>
            </div>
        </el-dialog>
        <el-image-viewer v-if="showViewer" :on-close="closeViewer" :url-list="srcList" :z-index="99999"/>
        <!-- 进度条 -->
        <el-progress v-if="searchApParams._visible" class="saveProgress" type="circle" :percentage="searchApParams._percentage" />
        <!--    销售历史    -->
        <el-dialog :close-on-click-modal="false" title="销售历史" :visible.sync="saleHistory" width="1200px">
            <div v-if="saleHistory">
                <APSalesHistory :EntpCusId="''" :EntpTempGoodsId="goodsId" :SId="submitData.InWarehouseId" :EntpCusName="''" @closeDialog="closeHistoryDialog"></APSalesHistory>
            </div>
        </el-dialog>        
        <!--    调入历史    -->
        <el-dialog :close-on-click-modal="false" :title="inHisTitle" :visible.sync="tInHistory" width="1200px">
            <div v-if="tInHistory">
                <APTransInHistory :OrderType="'0'" :IsShowCost="funcConfig" :GoodsId="goodsId" :SId="submitData.InWarehouseId" :WarehouseName="submitData.InWarehouseName" @closeDialog="closeHistoryDialog"></APTransInHistory>
            </div>
        </el-dialog>
        <!--    调出历史    -->
        <el-dialog :close-on-click-modal="false" :title="outHisTitle" :visible.sync="tOutHistory" width="1200px">
            <div v-if="tOutHistory">
                <APTransOutHistory :OrderType="'1'" :IsShowCost="funcConfig" :GoodsId="goodsId" :SId="submitData.OutWarehouseId" :WarehouseName="submitData.OutWarehouseName" @closeDialog="closeHistoryDialog"></APTransOutHistory>
            </div>
        </el-dialog>                     
    </div>
</template>
<script>
import mixin from '@/mixins/mixin';
import tableSets from '@/components/common/tableSets_v2.vue';
import jointSets from '@/components/common/jointSets.vue';
import APMsg from '@/components/common/APMsg';
import ElImageViewer from 'element-ui/packages/image/src/image-viewer';
import breadcrumb from '@/components/common/breadcrumb';
import APNeedOutDatas from '@/components/common/APNeedOutDatas';
import APNeedInDatas from '@/components/common/APNeedInDatas';
import APInquiryHistory from '@/components/common/APInquiryHistory';
import APSalesHistory from '@/components/common/ARSaleHistory';
import APTransInHistory from '@/components/common/APTransHistory';
import APTransOutHistory from '@/components/common/APTransHistory';
export default {
    mixins: [mixin],
    name: '',
    components: { tableSets, jointSets, APMsg, ElImageViewer, breadcrumb, APNeedOutDatas, APNeedInDatas, APInquiryHistory,APSalesHistory,APTransInHistory, APTransOutHistory},
    watch: {
        isStartSearch(newVal, oldVal) {
            if (newVal === true) {
                this.$nextTick(() => {
                    this.$refs.search_0.focus();
                    this.searchIndex = 0;
                });
            }
        },
        currentRow(newVal, oldVal) {
            this.srcList = [];
            if (newVal && newVal.MainImage && newVal.MainImage != oldVal.MainImage) {
                this.$nextTick(() => {
                    this.imageVisible = true;
                });
            } else {
                this.imageVisible = false;
            }
        },
        isStartConfirm(newVal, oldVal) {
            if (newVal === true) {
                this.$nextTick(() => {
                    this.$refs.confirm_0.focus();
                    this.confirmIndex = 0;
                });
            }
        }
    },
    beforeRouteLeave(to, from, next) {
        this.$util.confirmBeforeLeave(to, from, next, this);
    },
    data() {
        let userMsg = this.$util.getLocalStorage('userMsg');
        return {
            isTransNumSet: false,
            isCheckCode: true,
            isCanTBSet:false,
            downloadUrl: this.$util.QN_URL_BASE,
            type: 0,
            needConfirm: true,
            confirmIndex: 0,
            searchIndex: 0,
            currentRow: {},
            dataindex: 0,
            allNum: 0,
            allMoney: 0,
            datetime: '',
            searchVisible: false,
            jointSetVisible: false,
            searchLoading: false,
            saving: false,
            isStartSearch: false,
            isStartConfirm: false,
            rowVisible: false,
            rowForm: {},
            userMsg: userMsg,
            pageTitle: '',
            dataReadonly: false,
            WarehouseList: [],
            WarehouseNotAuthList: [],
            showOrderMsg: true,
            showResultMsg: false,
            APMsgVisible: false,
            EntpTempGoodsIdEdit: '',
            // 搜索配件弹框返回参数
            searchApParams: {
                _visible: false,
                _percentage: 0,
                _limit: 500,
                // 总数量
                _totalCount: 0
            },
            submitData: { TranCost: 0 },
            rules: {
                OutWarehouseId: [
                    {
                        required: true,
                        message: '请选择调出仓库',
                        trigger: 'blur'
                    }
                ],
                InWarehouseId: [
                    {
                        required: true,
                        message: '请选择调入仓库',
                        trigger: 'blur'
                    }
                ]
            },
            calcType: -1,
            calcTypeList: [
                { Text: '请选择', Value: -1 },
                { Text: '按价值分摊', Value: 0 },
                { Text: '按数量分摊', Value: 1 },
                { Text: '按点数直接调整', Value: 2 }
            ],
            point: 1,
            isCalcFirst: true,
            recoverList: [],
            tableData: [],
            tableDataLength: 0,
            searchData: {
                APCode: '',
                GoodCode: '',
                GoodName: '',
                GoodDesc: '',
                AutoSerise: '',
                AutoSeriseId: '',
                Brand: '',
                BrandName: [],
                Size: '',
                Cate: [],
                page: 1,
                limit: 15,
                CId: '',
                SId: '',
                SortProp: '',
                SortType: '',
                Source: '0',
                JointSearch: '',
                Symbol: '',
                Invent1: 0,
                Invent2: 0,
                Origin: '',
                SearchType: 2
            },
            tableCode: 'TransWHEdit',
            columnShowSets:[],
            tableSetsVisible: false,
            separator: '',
            pickerOptions: {
                shortcuts: [
                    {
                        text: '最近一周',
                        onClick(picker) {
                            const end = new Date();
                            const start = new Date();
                            start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
                            picker.$emit('pick', [start, end]);
                        }
                    },
                    {
                        text: '最近一个月',
                        onClick(picker) {
                            const end = new Date();
                            const start = new Date();
                            start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
                            picker.$emit('pick', [start, end]);
                        }
                    },
                    {
                        text: '最近三个月',
                        onClick(picker) {
                            const end = new Date();
                            const start = new Date();
                            start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
                            picker.$emit('pick', [start, end]);
                        }
                    },
                    {
                        text: '最近半年',
                        onClick(picker) {
                            const end = new Date();
                            const start = new Date();
                            start.setTime(start.getTime() - 3600 * 1000 * 24 * 180);
                            picker.$emit('pick', [start, end]);
                        }
                    },
                    {
                        text: '最近一年',
                        onClick(picker) {
                            const end = new Date();
                            const start = new Date();
                            start.setTime(start.getTime() - 3600 * 1000 * 24 * 365);
                            picker.$emit('pick', [start, end]);
                        }
                    }
                ]
            },
            scrollTop: 0,
            scrollLeft: 0,
            brandList: [],
            typeList: [],
            isRegister: false,
            optionLoading: false,
            goodNameOptions: [],
            goodNameForm: {
                Page: 1,
                Limit: 10,
                stopLoad: false,
                key: ''
            },
            autoSeriseOptions: [],
            autoSeriseForm: {
                Page: 1,
                Limit: 10,
                stopLoad: false,
                key: ''
            },
            canSearch: true,
            rowFormLoading: false,
            ownMoney: 0,
            imageVisible: false,
            srcList: [],
            showViewer: false,
            isShowSummary: false,
            summaryList: [],
            autoSeriesModel: {},
            nameCallBack: '',
            autoCallBack: '',
            isUseAS: false,
            dataList: [],
            sortActive: false,
            funcConfig: false,
            isAddWaitIn: false,
            isOriginSort: false,
            oldOutWarehouseId: '',
            needOutDataVisible: false,
            NeedOTitle: '',
            needInDataVisible: false,
            NeedITitle: '',
            inqHistoryVisible: false,
            tOutHistory:false,//调出历史
            tInHistory:false,//调入历史
            saleHistory:false,//销售历史
            goodsId:'',
            inHisTitle:'',
            outHisTitle:'',
            isShowRemain: false
        };
    },
    created() {
        document.addEventListener('keydown', this.handleKeyEvent);
        if (this.tableCode) {
            this.getSetsData();
            this.getJointSearchSets();
        }
    },
    mounted() {
        this.init();
        //当表格出现滚动条后，编辑最后一条数据时，点击滚动条内底部的空白处单元格的编辑状态没有去除
        //为了解决这个bug在表格的父级监听点击事件来清除单元格激活状态
        let tablebody = document.querySelector('.elx-table--body-wrapper');
        tablebody.addEventListener('click', this.clearActived, false);
    },
    computed: {
        // 列表数据最后一行下标
        lastRowIndex() {
            return Array.isArray(this.dataList) ? this.dataList.length - 1 : 0;
        }
    },
    filters: {
        AutoSeriseTextSplit(x) {
            if (~x.indexOf(',')) {
                return x.split(',').join('<br/>');
            } else {
                return x;
            }
        },
        SpaceTextSplit(x) {
            return x.join('<br/>');
        }
    },
    directives: {
        //用户选择栏的懒加载
        scrollLoad: {
            bind(el, binding, vnode) {
                //防抖函数
                function debounce(func, wait, immediate) {
                    //func函数，wait为时间周期
                    var timeout;
                    return function () {
                        var context = this,
                            args = arguments;
                        var later = function () {
                            timeout = null;
                            if (!immediate) {
                                func.apply(context, args);
                            }
                        };
                        var callNow = immediate && !timeout;
                        clearTimeout(timeout);
                        timeout = setTimeout(later, wait);
                        if (callNow) {
                            func.apply(context, args);
                        }
                    };
                }
                let wrapDom = el.querySelector('.el-autocomplete-suggestion__wrap');
                let listDom = el.querySelector('.el-autocomplete-suggestion__wrap  .el-autocomplete-suggestion__list');
                //将滚动事件通过参数传入防抖函数中
                var myEfficientFn = debounce(function () {
                    let condition = wrapDom.offsetHeight + wrapDom.scrollTop + 10 - listDom.offsetHeight;
                    if (condition > 0 && !vnode.context.loading) {
                        //滚动到底部则执行滚动方法load，binding.value就是v-scrollLoad绑定的值，加()表示执行绑定的方法
                        binding.value();
                    }
                }, 250);
                wrapDom.addEventListener('scroll', myEfficientFn, false); //绑定滚动事件
            }
        }
    },
    methods: {
        goback() {
            this.$router.push('/inventoryManage/transWarehouse');
        },
        handleKeyEvent(e) {
            let that = this;
            if (that.dataReadonly) return;
            let key = window.event.keyCode;
            if (key == 112) {
                e.preventDefault();
                that.goback();
                return;
            }
            if (key == 113) {
                e.preventDefault();
                if (!that.submitData.OutWarehouseId) {
                    that.$util.warningMsg('请先选择调出仓库');
                    return;
                }
                if (!that.searchVisible) {
                    that.resetSearch();
                    that.searchVisible = true;
                    that.hideMsg();
                    that.showResultFunc();
                    if (that.rowVisible) {
                        that.isStartConfirm = false;
                        that.rowVisible = false;
                    }
                }
                that.isStartSearch = true;
                return;
            }
            //F3
            if (key == 114) {
                e.preventDefault();
                if (!that.APMsgVisible) that.showAPMsgDialog();
                return;
            }
            //F4 调出历史
            if (key == 115) {
                e.preventDefault();
                if (!that.tOutHistory) that.showTOutHisDialog();
           
                return;
            }
            //F5 调入历史
            if (key == 116) {
                e.preventDefault();
                if (!that.tInHistory) that.showTInHisDialog();
                return;
            }
            //F6 销售历史
            if (key == 117) {
                e.preventDefault();
                if (!that.saleHistory) that.showSaleHisDialog();
                return;
            }            
            if (key == 122) {
                //F11
                e.preventDefault();
                if (!(that.type == 2 || that.type == 3 || that.type == 4)) return;
                if (!that.tableSetsVisible && !that.jointSetVisible && !that.APMsgVisible) {
                    that.save();
                    return;
                }
                return;
            }
            if (key == 123) {
                //F12
                e.preventDefault();
                if (!(that.type == 2 || that.type == 3)) return;
                if (!that.tableSetsVisible && !that.jointSetVisible && !that.APMsgVisible) {
                    that.saveAndAdd();
                    return;
                }
                return;
            }
            if (key === 13) {
                //Enter
                if (!that.needInDataVisible && !that.needOutDataVisible && !that.inqHistoryVisible && !that.tableSetsVisible && !that.jointSetVisible && !that.APMsgVisible) {
                    e.preventDefault();
                    if (!that.searchVisible && that.currentRow && that.currentRow.EntpTempGoodsId) {
                        if (!that.rowVisible) {
                            that.dblChooseAps(that.currentRow);
                            if (that.searchVisible) {
                                that.searchVisible = false;
                                that.isStartSearch = false;
                            }
                        } else {
                            if (!that.rowFormLoading) that.rowConfirm();
                        }
                    } else if (
                        that.searchVisible &&
                        !that.rowVisible &&
                        that.$refs.search_5 &&
                        !that.$refs.search_5.visible &&
                        that.$refs.search_6 &&
                        !that.$refs.search_6.visible &&
                        that.canSearch
                    )
                        that.handleSearch();
                    that.canSearch = true;
                }
                return;
            }
            if (key === 27) {
                that.canSearch = true;
                that.showViewer = false;
                that.imageVisible = false;
                if ((that.$refs.search_2 && that.$refs.search_2.suggestionVisible) || (that.$refs.search_3 && that.$refs.search_3.suggestionVisible)) {
                    if (that.$refs.search_2 && that.$refs.search_2.suggestionVisible) that.$refs.search_2.suggestions = [];
                    if (that.$refs.search_3.suggestionVisible) that.$refs.search_3.suggestions = [];
                    return;
                }
                //ESC
                if (!that.needInDataVisible && !that.needOutDataVisible && !that.inqHistoryVisible && !that.tableSetsVisible && !that.jointSetVisible && !that.APMsgVisible) {
                    e.preventDefault();
                    if (that.searchVisible && !that.rowVisible) {
                        that.searchVisible = false;
                        that.isStartSearch = false;
                    } else if (!that.searchVisible && that.rowVisible) {
                        that.rowVisible = false;
                        that.isStartConfirm = false;
                    }
                    if (that.APMsgVisible) that.APMsgVisible = false;
                }
                return;
            }
            //上键
            if (key == 38) {
                that.canSearch = true;
                if (
                    !that.needInDataVisible &&
                    !that.needOutDataVisible &&
                    !that.inqHistoryVisible &&
                    !that.tableSetsVisible &&
                    !that.jointSetVisible &&
                    !that.APMsgVisible &&
                    !that.showViewer
                ) {
                    e.preventDefault();
                    if (!that.rowVisible && !that.searchVisible) {
                        //光标已经在编辑框内，不可上下移动
                        var cursorFocus = document.querySelector('input:focus');
                        if (cursorFocus) {
                            e.preventDefault();
                            return;
                        }
                        if (that.dataindex != 0) {
                            that.dataindex--;
                            let index = that.dataindex;
                            that.$nextTick(() => {
                                if (that.$refs.multipleTable) {
                                    that.currentRow = that.$refs.multipleTable.data[index];
                                    that.$refs.multipleTable.setCurrentRow(that.$refs.multipleTable.data[index]);
                                    that.$refs.multipleTable.scrollToRow(that.tableData[that.dataindex - 5]);
                                    that.getInvenDatas(that.currentRow);
                                }
                            });
                        }
                    } else if (!that.rowVisible && that.searchVisible) {
                        if (that.searchIndex != 0) {
                            if (
                                (!that.$refs.search_5 || !that.$refs.search_5.visible) &&
                                (!that.$refs.search_6 || !that.$refs.search_6.visible) &&
                                (!that.$refs.search_2 || !that.$refs.search_2.suggestionVisible) &&
                                (!that.$refs.search_3 || !that.$refs.search_3.suggestionVisible)
                            ) {
                                if (that.searchIndex == 5 || that.searchIndex == 6) {
                                    if (that.$refs[`search_` + that.searchIndex]) that.$refs[`search_` + that.searchIndex].blur();
                                }
                                that.searchIndex -= 1;
                                if (that.$refs[`search_` + that.searchIndex]) that.$refs[`search_` + that.searchIndex].focus();
                            }
                        }
                    } else if (that.rowVisible && !that.searchVisible) {
                        if (that.confirmIndex != 0) {
                            that.confirmIndex -= 1;
                            if (that.$refs[`confirm_` + that.confirmIndex]) that.$refs[`confirm_` + that.confirmIndex].focus();
                        }
                    }
                    return;
                }
                return;
            }
            //下键
            if (key == 40) {
                that.canSearch = true;
                if (
                    !that.needInDataVisible &&
                    !that.needOutDataVisible &&
                    !that.inqHistoryVisible &&
                    !that.tableSetsVisible &&
                    !that.jointSetVisible &&
                    !that.APMsgVisible &&
                    !that.showViewer
                ) {
                    e.preventDefault();
                    if (!that.rowVisible && !that.searchVisible) {
                        //光标已经在编辑框内，不可上下移动
                        cursorFocus = document.querySelector('input:focus');
                        if (cursorFocus) {
                            e.preventDefault();
                            return;
                        }
                        if (that.dataindex != that.tableDataLength - 1) {
                            if (that.currentRow && that.currentRow.EntpTempGoodsId) {
                                that.dataindex++;
                            } else that.dataindex = 0;
                            let index = that.dataindex;
                            that.$nextTick(() => {
                                if (that.$refs.multipleTable) {
                                    that.currentRow = that.$refs.multipleTable.data[index];
                                    that.$refs.multipleTable.setCurrentRow(that.$refs.multipleTable.data[index]);
                                    //两个定位是为了确认选中行一定在当前展示中
                                    that.$refs.multipleTable.scrollToRow(that.tableData[that.dataindex + 4]);
                                    that.$refs.multipleTable.scrollToRow(that.$refs.multipleTable.data[index]);
                                    that.getInvenDatas(that.currentRow);
                                }
                            });
                            if (that.dataindex > that.tableData.length - 10 && !that.searchLoading && that.dataindex < that.tableDataLength - 14) that.downKeyToLoad();
                        }
                    } else if (!that.rowVisible && that.searchVisible) {
                        if (that.searchIndex != 10) {
                            if (
                                (!that.$refs.search_5 || !that.$refs.search_5.visible) &&
                                (!that.$refs.search_6 || !that.$refs.search_6.visible) &&
                                (!that.$refs.search_2 || !that.$refs.search_2.suggestionVisible) &&
                                (!that.$refs.search_3 || !that.$refs.search_3.suggestionVisible)
                            ) {
                                if (that.searchIndex == 5 || that.searchIndex == 6) {
                                    if (that.$refs[`search_` + that.searchIndex]) that.$refs[`search_` + that.searchIndex].blur();
                                }
                                that.searchIndex += 1;
                                if (that.$refs[`search_` + that.searchIndex]) that.$refs[`search_` + that.searchIndex].focus();
                            }
                        }
                    } else if (that.rowVisible && !that.searchVisible) {
                        if (that.confirmIndex != 2) {
                            that.confirmIndex += 1;
                            if (that.$refs[`confirm_` + that.confirmIndex]) that.$refs[`confirm_` + that.confirmIndex].focus();
                        }
                    }
                    return;
                }
                return;
            }
        },
        //手动清除单元格激活状态
        clearActived(e) {
            if (e.target.className == 'elx-table--body-wrapper body--wrapper') {
                this.$refs.infiniteTable.clearActived();
            }
            e.stopPropagation();
            e.preventDefault();
        },
        getSetsData() {
            this.columnShowSets = [];
            this.$util.getTableSetsData(this.tableCode).then(data => {
                data.forEach(item => {
                    let colums = {
                        IsShow: item.IsShow,
                        Width: item.Width,
                        ColumnName: item.ColumnName,
                        ColumnCode: item.ColumnCode,
                        SortNum: item.SortNum,
                        IsSort: item.IsSort
                    };

                    this.columnShowSets.push(colums);
                });
            });
        },
        getJointSearchSets() {
            this.$util.getJointSearchSetsData(true).then(data => {
                data.forEach(item => {
                    if (item.IsSeparator) {
                        this.separator = item.Separator;
                        return;
                    }
                });
            });
        },
        getConfigByCodes() {
            return new Promise(resolve => {
                let codes = ['xsgdy', 'lybsdr', 'xskdmrcdpx','ygsfkzdylb','xzqpbmdwyx', 'dmslmr','dbdbjymlys'];
                this.$util.getSysConfigs(codes).then(data => {
                    if (data) {
                        for (let i = 0; i < data.length; i++) {
                            let code = data[i].Code;
                            let result = data[i].Result;
                            let rValue = data[i].RValue;
                            switch (code) {
                                case 'dbdzscksjl':
                                    this.funcConfig = result;
                                    break;
                                case 'lybsdr':
                                    this.isAddWaitIn = !result;
                                    break;
                                case 'xskdmrcdpx': //是否默认产地排序
                                    this.isOriginSort = result;
                                    break;
                                case 'ygsfkzdylb': //是否可自定义列表
                                    this.isCanTBSet = result;
                                    break;          
                                case 'xzqpbmdwyx': //是否检测编码重复
                                    this.isCheckCode = result;
                                    break;          
                                case 'dmslmr': //调拨默认数赋值为1
                                    this.isTransNumSet = result;
                                    break;  
                                case 'dbdbjymlys':
                                    this.isShowRemain = result;
                                    break;  
                            }
                        }
                    }
                    resolve();
                });
            });
        },
        // 获取仓库列表
        getWarehouse() {
            this.$util.getWarehouse(1).then(data => {
                this.WarehouseList = data;
            });
        },
        getWarehouseNotAuth() {
            this.$util.getWarehouseNotAuth(1).then(data => {
                this.WarehouseNotAuthList = data;
            });
        },
        init() {
            let that = this;
            that.type = Number(this.$route.query.type);
            that.submitData.TOId = this.$route.query.TOId;
            let transOrderModel = '';
            let datalist = '';
            that.getConfigByCodes().then(() => {
                switch (that.type) {
                    case 1:
                        this.pageTitle = '查看调拨单';
                        this.dataReadonly = true;
                        this.getTableData();
                        break;
                    case 2:
                        this.pageTitle = '编辑调拨单';
                        transOrderModel = this.$util.getLocalStorage('transOrder');
                        datalist = this.$util.getLocalStorage('transOrder_dataList');
                        //判断缓存是否有数据，如果有取缓存数据
                        if (transOrderModel && datalist && datalist.length > 0) {
                            this.getDataFromChace();
                        } else {
                            this.getTableData();
                        }
                        break;
                    case 3:
                        this.pageTitle = '新增调拨单';
                        this.getWarehouse();
                        this.getWarehouseNotAuth();
                        transOrderModel = this.$util.getLocalStorage('transOrder');
                        datalist = this.$util.getLocalStorage('transOrder_dataList');
                        //判断缓存是否有数据，如果有取缓存数据
                        if (transOrderModel && datalist && datalist.length > 0) {
                            this.getDataFromChace();
                        }
                        break;
                    case 4:
                        this.pageTitle = '修改调拨单';
                        transOrderModel = this.$util.getLocalStorage('transOrder');
                        datalist = this.$util.getLocalStorage('transOrder_dataList');
                        //判断缓存是否有数据，如果有取缓存数据
                        if (transOrderModel && datalist && datalist.length > 0) {
                            this.getDataFromChace();
                        } else {
                            this.getTableData();
                        }
                        break;
                    default:
                        break;
                }
            });
        },
        // 数量或者价格变动
        priceChange() {
            let DetailList = this.dataList;
            let _allNum = 0;
            let _allMoney = 0;
            for (let i = 0; i < DetailList.length; i++) {
                _allNum += Number(DetailList[i].Count);
                _allMoney += Number(DetailList[i].Count * DetailList[i].CostPrice ? (DetailList[i].Count * DetailList[i].CostPrice).toFixed(3) : 0);
            }
            this.allMoney = _allMoney.toFixed(2);
            this.allNum = _allNum;
        },
        // 搜索
        showSearch() {
            if (!this.submitData.OutWarehouseId) {
                this.$util.warningMsg('请先选择调出仓库');
                return;
            }
            this.resetSearch();
            this.searchVisible = true;
            this.isStartSearch = true;
            this.showResultFunc();
            this.hideMsg();
        },
        closeSearchDialog() {
            this.isStartSearch = false;
        },
        // 配件信息
        hideMsg() {
            this.showOrderMsg = false;
            if (this.$refs.cusselect) this.$refs.cusselect.blur();
        },
        showMsg() {
            this.showOrderMsg = true;
        },
        hideResultFunc() {
            this.showResultMsg = false;
        },
        showResultFunc() {
            this.showResultMsg = true;
        },
        OutWarehouseChange(val) {
            var obj = {};
            let that = this;
            if (that.submitData.InWarehouseId && that.submitData.InWarehouseId === val) {
                that.submitData.InWarehouseId = '';
                that.$util.warningMsg('调入仓库和调出仓库不能相同');
                return;
            }

            if (that.dataList.length > 0) {
                that.$confirm('修改原有调出仓库会清空已选择的商品，您确定要修改吗?', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    distinguishCancelAndClose: true,
                    closeOnClickModal: false,
                    type: 'warning'
                })
                    .then(() => {
                        that.oldOutWarehouseId = val;
                        that.dataList = [];
                        that.recoverList = [];
                        that.tableData = [];
                        that.tableDataLength = 0;
                        that.allMoney = 0;
                        that.allNum = 0;
                    })
                    .catch(() => {
                        that.submitData.OutWarehouseId = that.oldOutWarehouseId;
                    });
            } else {
                that.oldOutWarehouseId = val;
            }
            if(val){
                let w = that.WarehouseList.find(e => e.WarehouseId == val);
                that.submitData.OutWarehouseName=w?w.WarehouseName:'';
            }else{
                that.submitData.OutWarehouseName="";
            }
        },
        // 调入仓库发生改变
        InWarehouseChange(val) {
            let that=this;
            if (val && val == that.submitData.OutWarehouseId) {
                that.submitData.InWarehouseId = '';
                that.$util.warningMsg('调入仓库和调出仓库不能相同');
                return;
            }
            if(val){
                let w = that.WarehouseNotAuthList.find(e => e.WarehouseId == val);
                that.submitData.InWarehouseName=w?w.WarehouseName:'';
            }else{
                that.submitData.InWarehouseName="";
            }            
        },
        calcShare() {
            let that = this;
            if (that.dataList.length == 0) {
                that.$message.error('未检测到要计算的分摊的成本');
                return;
            }
            if (that.calcType == 2) {
                if (that.isCalcFirst) {
                    that.isCalcFirst = false;
                    if (that.point) {
                        that.dataList.forEach(item => {
                            item.CostPrice = (item.CostPrice * that.point).toFixed(2);
                        });
                    } else that.$message.error('计算的点数异常，请重新填写');
                }
                return;
            } else if ((that.calcType == 1 || that.calcType == 0) && that.submitData.TranCost != 0) {
                if (that.isCalcFirst) {
                    that.isCalcFirst = false;
                    let list = that.dataList;
                    let costTotal = that.submitData.TranCost;
                    let supTotal = 0;
                    let supCount = 0;
                    list.forEach(item => {
                        supTotal += item.CostPrice;
                        supCount += item.Count;
                    });
                    that.dataList.forEach(item => {
                        if (that.calcType == 0) {
                            item.CostPrice = (item.CostPrice + Number((item.CostPrice * (costTotal / supTotal)) / item.Count)).toFixed(2);
                        } else {
                            item.CostPrice = (item.CostPrice + Number(costTotal / supCount)).toFixed(2);
                        }
                    });
                }
                return;
            } else {
                that.$message.error('未检测到要计算的分摊的成本');
                return;
            }
        },
        recoverCalc() {
            let that = this;
            that.dataList.forEach(item => {
                let data = that.recoverList.find(e => e.EntpTempGoodsId == item.EntpTempGoodsId);
                item.CostPrice = data.CostPrice;
            });
            that.isCalcFirst = true;
        },
        showTableSetDialog() {
            this.tableSetsVisible = true;
        },
        closeTableSetDialog(edit) {
            this.tableSetsVisible = false;
        },
        onDateTimeSelect(val) {
            if (val != null) {
                this.searchData.InStartDate = val[0];
                this.searchData.InEndDate = val[1];
            } else {
                this.searchData.InStartDate = '';
                this.searchData.InEndDate = '';
            }
        },
        closeJointDialog() {
            this.jointSetVisible = false;
        },
        jointSets() {
            this.jointSetVisible = true;
        },
        sortChange(event) {
            this.searchData.SortProp = event.prop;
            this.searchData.SortType = event.order ? event.order : '';
            if (this.searchData.SortType == '') this.searchData.SortProp = '';
            this.searchData.page = 1;
            this.dataindex = -1;
            this.tableData = [];
            this.scrollTop = 0;
            this.scrollLeft = 0;
            this.getAPTableData();
        },
        /**
         * 表格滚动
         * 只有在滚动到底部，并且下方还有数据的情况下刷新
         */
        tableLoad({ scrollTop, scrollLeft }, event) {
            var t = event.currentTarget.scrollTop; // 表格内容已滚动的高度
            var s = event.currentTarget.scrollHeight; // 表格内容撑起的高度
            var c = event.currentTarget.clientHeight; // 表格视窗高度 即wraper
            if (scrollTop > this.scrollTop && !this.stopFresh && t + c >= s - 50) {
                //第一页还没有数据就去请求第二页，想太多了吧`(*>﹏<*)′
                if (this.tableData && this.tableData.length > 0) {
                    this.searchData.page += 1;
                    if (scrollTop !== 0) this.scrollTop = scrollTop;
                    this.scrollLeft = scrollLeft;
                } else {
                    this.searchData.page = 1;
                    this.scrollTop = 0;
                    this.scrollLeft = 0;
                }
                this.getAPTableData();
            }
        },
        downKeyToLoad() {
            if (this.tableData && this.tableData.length > 0) {
                this.searchData.page += 1;
            } else {
                this.searchData.page = 1;
            }
            this.getAPTableData();
        },
        getAPTableData() {
            if (this.searchData.Symbol) {
                if (this.searchData.Symbol == 'between') {
                    if (isNaN(this.searchData.Invent1)) {
                        this.$util.warningMsg('请输入正确的库存数');
                        return;
                    }
                    if (isNaN(this.searchData.Invent2)) {
                        this.$util.warningMsg('请输入正确的库存数');
                        return;
                    }
                    if (this.searchData.Invent1 <= 0 || this.searchData.Invent2 <= 0) {
                        this.$util.warningMsg('调拨的商品库存数必须大于零');
                        return;
                    }
                } else {
                    if (isNaN(this.searchData.Invent1)) {
                        this.$util.warningMsg('请输入正确的库存数');
                        return;
                    }
                }
                if (this.searchData.Invent1 <= 0) {
                    this.$util.warningMsg('调拨的商品库存数必须大于零');
                    return;
                }
            } else {
                if (!this.searchData.Invent1) this.searchData.Invent1 = 0;
                if (!this.searchData.Invent2) this.searchData.Invent2 = 0;
            }
            if (this.isOriginSort && !this.searchData.SortProp) {
                this.searchData.SortProp = 'Origin';
                this.searchData.SortType = 'descending';
            }
            this.searchData.CId = this.submitData.EntpCusId;
            this.searchData.SId = this.submitData.OutWarehouseId;
            if (this.SelectedData && this.SelectedData.length > 0) {
                this.searchData.SelectedData = this.SelectedData;
            }

            if (this.autoSeriesModel) {
                if (this.isUseAS) this.searchData.AutoSeriseId = this.autoSeriesModel.AutoSeriesId;
                else this.searchData.AutoSeriseId = '';
            }

            if (this.searchData.page == 1) {
                this.searchParams = {
                    ...this.searchData
                };
            } else {
                this.searchParams.page = this.searchData.page;
            }
            this.searchLoading = true;
            this.stopFresh = true;
            this.$util
                .axiosPost({
                    url: '/api/EntpGoods/GetGoodsListForEditTransOrder_V2',
                    data: this.searchParams,
                    hideLoading: true
                })
                .then(res => {
                    let data = res.data;
                    this.tableDataLength = res.count;
                    if (!data) {
                        if (this.searchData.page == 1) this.tableData = [];
                        return;
                    }

                    for (let i = 0; i < data.length; i++) {
                        data[i].LoadSpaceInvent = true;
                    }

                    let list = [...this.tableData, ...data];
                    const maps = new Map();
                    list = list.filter(m => !maps.has(m.EntpTempGoodsId) && maps.set(m.EntpTempGoodsId, 1));

                    //因为接口的原因，返回前后两页数据有重复，所以在这里做去重
                    this.tableData = list;

                    if (this.dataList.length > 0) {
                        this.tableData.forEach(goods => {
                            let idx = this.dataList.findIndex(f => f.EntpTempGoodsId == goods.EntpTempGoodsId);
                            if (idx > -1) {
                                goods.IsSelected = true;
                            }
                        });
                    }
                    this.stopFresh = data.length < this.searchData.limit;
                    
                    var isShow = this.columnShowSets.find(x=> 
                        (x.ColumnCode == 'OrderWaitOutQuantity'
                        || x.ColumnCode == 'POrderWaitInQuantity'
                        || x.ColumnCode == 'PlanPurchase') && x.IsShow)

                        if (isShow)
                            this.getOtherData(data);
                })
                .catch(e => {})
                .finally(() => {
                    this.searchLoading = false;
                });
        },
        async getOtherData(data) {
            let that = this;
            if (data && data.length > 0) {
                for (let i = 0; i < data.length; i++) {
                    that.loopGetData(data[i].EntpTempGoodsId);
                    await that.$util.sleep(150);
                }
            }
        },
        loopGetData(id) {
            let that = this;
            var isShow1 = that.columnShowSets.find(x=> x.ColumnCode == 'OrderWaitOutQuantity')
            var isShow2 = that.columnShowSets.find(x=> x.ColumnCode == 'POrderWaitInQuantity')
            var isShow3 = that.columnShowSets.find(x=> x.ColumnCode == 'PlanPurchase')
            
            that.$util
                .axiosGet({
                    url: '/api/EntpGoods/GetAfteSearchPartData_V3',
                    data: {
                        goodsId: id,
                        sId: this.searchData.SId,
                        isShowPlanPur: isShow3.IsShow,
                        isShowOrderWaitOut: isShow1.IsShow,
                        isShowPOrderWaitIn: isShow2.IsShow
                    },
                    hideLoading: true
                })
                .then(res => {
                    let data = res.data;
                    if (!data) {
                        return;
                    }
                    that.tableData.forEach(item => {
                        if (item.EntpTempGoodsId == data.GoodsId) {
                            item.LoadSpaceInvent = false;
                            item.OrderWaitOutQuantity = data.OrderWaitOutQuantity;
                            item.POrderWaitInQuantity = data.POrderWaitInQuantity;
                            item.PlanPurchase = data.PlanPurchase;
                            item.Remaining = item.StorageInventory + (this.isAddWaitIn ? data.POrderWaitInQuantity : 0) - data.OrderWaitOutQuantity

                            return;
                        }
                    });
                })
                .catch(() => {});
        },
        chooseAllAPsHandle() {
            let that = this;
            that.$confirm('是否将查询结果全部加入到订单商品明细中？', '', {
                type: 'warning',
                distinguishCancelAndClose: true
            })
                .then(() => {
                    this.searchApParams = {
                        ...this.searchData,
                        limit: this.searchApParams._limit,
                        _visible: true,
                        _percentage: 0,
                        _limit: this.searchApParams._limit,
                        _totalCount: this.tableDataLength
                    };
                    this.loopSearch();
                })
                .catch(() => {});
        },
        // 开始循环
        async loopSearch() {
            const { data } = await this.$util.axiosPost({
                url: '/api/EntpGoods/GetGoodsListForEditTransOrder_V2',
                data: this.searchApParams,
                hideLoading: true
            });
            this.searchApParams._percentage = parseInt(((this.searchApParams.page * this.searchApParams.limit) / this.searchApParams._totalCount) * 100);

            this.searchApParams.page += 1;
            let _stop = !data || data.length < this.searchApParams._limit;
            this.addToList(data);
            if (_stop) {
                this.searchApParams._percentage = 100;
                this.searchApParams._visible = false;
            } else {
                this.loopSearch();
            }
        },
        addToList(items) {
            let that = this;
            let itemList = [...items];
            let newGoodsList = [];
            for (let i = 0; i < itemList.length; i++) {
                let item = itemList[i];
                let isExist = false;
                that.dataList.forEach((e, index) => {
                    if (item.EntpTempGoodsId == e.EntpTempGoodsId) {
                        isExist = true;
                        e.StorageInventory = item.StorageInventory;
                        e.MarketPrice = item.LatestPrice > 0 ? item.LatestPrice : '';
                    }
                });
                if (!isExist) {
                    let newGoods = {
                        ReferencePrice: item.ReferencePrice,
                        EntpTempGoodsId: item.EntpTempGoodsId,
                        APCode: item.APCode,
                        GoodName: item.GoodName,
                        GoodNameItem: item.GoodName,
                        AutoSerise: item.AutoSerise,
                        AutoSeriseItem: item.AutoSerise,
                        Count: item.StorageInventory,
                        OriginalCount: item.StorageInventory,
                        MarketPrice: item.MarketPrice,
                        Unit: item.Unit,
                        Origin: item.Origin,
                        Remark: '',
                        CodeRepeat: false,
                        Inventory: item.Inventory,
                        StorageInventory: item.StorageInventory,
                        WarehousedCount: 0,
                        OrderWaitOutQuantity: item.OrderWaitOutQuantity,
                        POrderWaitInQuantity: item.POrderWaitInQuantity,
                        LatestSalesTime: item.LatestSalesTime,
                        LatestQuoteTime: item.LatestQuoteTime,
                        State: 0,
                        canEdit: true,
                        IntenCount: item.IntenCount,
                        CostPrice: item.CostPrice,
                        BillingPrice: item.MarketPrice == 0 ? '' : item.MarketPrice,
                        Size: item.Size,
                        Cate: item.Cate,
                        Brand: item.Brand
                    };
                    if (!isNaN(item._count)) {
                        newGoods.Count = item._count;
                    }
                    if (!isNaN(item._price)) {
                        newGoods.CostPrice = item._price;
                    }
                    newGoodsList.push(newGoods);
                    that.recoverList.concat([...newGoodsList]);
                }
            }
            //判断最后一条数据是否空值，是的话移到最后，noClose 表示不关闭弹框
            if (that.dataList.length == 0) {
                that.dataList = that.dataList.concat(newGoodsList);
            } else {
                let lastItem = that.dataList[that.dataList.length - 1];
                if (!lastItem.APCode && !lastItem.GoodName) {
                    that.dataList.splice(that.dataList.length - 1, 1);
                    that.dataList = that.dataList.concat(newGoodsList);
                    that.dataList.push(lastItem);
                } else {
                    that.dataList = that.dataList.concat(newGoodsList);
                }
            }
            that.addPageChace();
            that.priceChange();
        },
        searchGoodName(key, cb) {
            if (![undefined].includes(key)) {
                this.goodNameForm.Page = 1;
                this.goodNameForm.stopLoad = false;
                this.goodNameForm.key = key;
                this.goodNameOptions = [];
            }
            if (cb) {
                this.nameCallBack = cb;
            }
            if (this.goodNameForm.stopLoad) return;
            this.optionLoading = true;
            this.$util.searchPartAttr(this.goodNameForm.key, 1, this.goodNameForm.Page, this.goodNameForm.Limit).then(data => {
                this.optionLoading = false;
                let arr = [];
                if (data) {
                    this.goodNameForm.stopLoad = data.length < this.goodNameForm.Limit;
                    data.forEach(e => {
                        arr.push({ value: e });
                    });
                }
                this.goodNameOptions = [...this.goodNameOptions, ...arr];
                if (this.nameCallBack) {
                    this.nameCallBack(this.goodNameOptions);
                }
            });
        },
        searchGoodNameLoad() {
            this.goodNameForm.Page += 1;
            this.searchGoodName();
        },
        searchAutoSerise(key, cb) {
            if (![undefined].includes(key)) {
                this.autoSeriseForm.Page = 1;
                this.autoSeriseForm.stopLoad = false;
                this.autoSeriseForm.key = key;
                this.autoSeriseOptions = [];
            }
            if (cb) {
                this.autoCallBack = cb;
            }
            if (this.autoSeriseForm.stopLoad) return;
            this.$util.searchPartAttr(this.autoSeriseForm.key, 2, this.autoSeriseForm.Page, this.autoSeriseForm.Limit).then(data => {
                let arr = [];
                if (data) {
                    this.autoSeriseForm.stopLoad = data.length < this.autoSeriseForm.Limit;
                    data.forEach(e => {
                        arr.push({ value: e });
                    });
                }
                this.autoSeriseOptions = [...this.autoSeriseOptions, ...arr];
                if (this.autoCallBack) {
                    this.autoCallBack(this.autoSeriseOptions);
                }
            });
        },
        searchAutoSeriseLoad() {
            this.autoSeriseForm.Page += 1;
            this.searchAutoSerise();
        },
        stopSearch() {
            this.canSearch = false;
        },
        closeViewer() {
            this.showViewer = false;
            this.$message.closeAll();
        },
        async getGoodsImages() {
            if (this.currentRow) {
                if (!this.srcList || this.srcList.length == 0) {
                    const { data } = await this.$util.axiosGet({
                        url: '/api/EntpGoods/GetGoodsImages',
                        data: { goodsId: this.currentRow.EntpTempGoodsId }
                    });
                    if (data) {
                        this.srcList = data;
                    }
                }
                this.showViewer = true;
                this.$message({
                    message: this.currentRow.APCode,
                    center: true,
                    duration: 0,
                    customClass: 'apcode_msgCls'
                });
            }
        },
        closeAutoSeries() {
            this.autoSeriesModel = {};
            this.searchData.AutoSeriseId = '';
        },
        resetSearch() {
            this.searchData = {
                APCode: '',
                GoodCode: '',
                GoodName: '',
                GoodDesc: '',
                AutoSerise: '',
                AutoSeriseId: '',
                Brand: '',
                BrandName: [],
                Size: '',
                Cate: [],
                page: 1,
                limit: 15,
                CId: '',
                SId: '',
                SortProp: '',
                SortType: '',
                Source: '0',
                JointSearch: '',
                Symbol: '',
                Invent1: 0,
                Invent2: 0,
                Origin: '',
                SearchType: 2
            };
            this.datetime = [];
            this.isSearch = false;
        },
        handleSearch() {
            let that = this;
            that.searchData.page = 1;
            that.dataindex = -1;
            that.tableData = [];
            that.isSearch = true;
            that.scrollTop = 0;

            if (!that.searchLoading) {
                that.getAPTableData();
            }
            if (that.searchVisible) {
                that.searchVisible = false;
                that.isStartSearch = false;
            }
        },
        getGoodsBrand() {
            if (this.brandList.length > 0) return;
            this.loading = true;
            this.$util
                .searchGoodsBrand()
                .then(data => {
                    this.brandList = data;
                    this.loading = false;
                })
                .catch(() => {
                    this.loading = false;
                });
        },
        getGoodsType() {
            if (this.typeList.length > 0) return;
            this.loading = true;
            this.$util
                .searchGoodsType()
                .then(data => {
                    this.typeList = data;
                    this.loading = false;
                })
                .catch(() => {
                    this.loading = false;
                });
        },
        tableRowClassName({ row, rowIndex }) {
            //把每一行的索引放进row
            row.index = rowIndex;
        },
        rowClick(row, column, event) {
            let that = this;
            that.dataindex = row.index;
            that.currentRow = row;
            that.getInvenDatas(row);
        },
        getInvenDatas(row) {
            let that = this;
            if (!row) return;
            that.$util
                .axiosGet({
                    url: '/api/EntpGoods/GetGoodsStorageInvens',
                    data: {
                        GoodsId: row.EntpTempGoodsId
                    },
                    hideLoading: true
                })
                .then(res => {
                    let data = res.data;
                    if (!data) {
                        return;
                    }
                    that.isShowSummary = true;
                    that.summaryList = data;
                })
                .catch(() => {});
        },
        // 列表双击打开弹框
        dblChooseAps(e) {
            let that = this;
            //先获取一些数据
            if ([e][0]) {
                // that.rowFormLoading = true;
                that.rowVisible = true;
                that.isStartConfirm = true;
                that.rowForm = {
                    ...[e][0],
                    _price: e.CostPrice,
                    _count: that.isTransNumSet? 1: e.StorageInventory
                };
            }
        },
        rowConfirm() {
            let that = this;
            let item = that.rowForm;
            let sIdx = that.tableData.findIndex(f => f.EntpTempGoodsId === item.EntpTempGoodsId);
            if (sIdx > -1) {
                that.tableData[sIdx].IsSelected = true;
            }
            let fIdx = that.dataList.findIndex(f => f.EntpTempGoodsId === item.EntpTempGoodsId);
            if (fIdx > -1) {
                that.dataList[fIdx].Count = item._count;
                that.dataList[fIdx].CostPrice = item._price;
                that.dataList[fIdx].BillingPrice = item._biilPrice;
            } else {
                let newGoods = {};
                newGoods = {
                    ReferencePrice: item.ReferencePrice,
                    EntpTempGoodsId: item.EntpTempGoodsId,
                    APCode: item.APCode,
                    GoodName: item.GoodName,
                    GoodNameItem: item.GoodName,
                    AutoSerise: item.AutoSerise,
                    AutoSeriseItem: item.AutoSerise,
                    Count: item._count,
                    OriginalCount: item.StorageInventory,
                    MarketPrice: item.MarketPrice,
                    Unit: item.Unit,
                    Remark: '',
                    CodeRepeat: false,
                    Inventory: item.Inventory,
                    StorageInventory: item.StorageInventory,
                    WarehousedCount: 0,
                    OrderWaitOutQuantity: item.OrderWaitOutQuantity,
                    POrderWaitInQuantity: item.POrderWaitInQuantity,
                    LatestSalesTime: item.LatestSalesTime,
                    LatestQuoteTime: item.LatestQuoteTime,
                    State: 0,
                    canEdit: true,
                    IntenCount: item.IntenCount,
                    CostPrice: item._price,
                    BillingPrice: item._biilPrice,
                    Origin: item.Origin,
                    Size: item.Size,
                    Cate: item.Cate,
                    Brand: item.Brand
                };
                that.dataList.push(newGoods);
                that.recoverList.push({ ...newGoods });
            }
            that.addPageChace();
            that.priceChange();
            that.rowVisible = false;
            that.isStartConfirm = false;
            setTimeout(() => {
                this.$refs.infiniteTable.scrollToRow(this.dataList[this.dataList.length - 1]);
                // this.$refs.infiniteTable.setActiveRow(this.dataList[this.dataList.length - 1]);
                if (this.dataList.length > 1) {
                    let ilEle = document.getElementsByClassName('business-content')[0];
                    ilEle.scrollTop = ilEle.scrollHeight;
                }
            }, 100);
        },
        rowClose() {
            this.rowVisible = false;
            this.isStartConfirm = false;
            this.rowForm = {};
        },
        change(e, type) {
            let that = this;
            if (!that.rowVisible) {
                let fIdx = that.dataList.findIndex(f => f.EntpTempGoodsId === that.currentRow.EntpTempGoodsId);
                if (fIdx > -1) {
                    that.dataList[fIdx].Count = that.rowForm._count;
                    that.dataList[fIdx].CostPrice = that.rowForm._price;
                }
            } 
        },
        // 设置展示行样式
        setRowStyle(param) {
            const { row, index } = param;
            let rowArr = [];
            if(this.isCheckCode)
                rowArr = this.dataList.filter(f => f.APCode === row.APCode);
            else
                rowArr = this.dataList.filter(f => f.EntpTempGoodsId === row.EntpTempGoodsId);
            if (rowArr.length > 1) {
                return `background-color: #FFE8E8`;
            }
        },
        // 编码排序
        changeTableSort(type, prop) {
            let sortArr = [];
            let listArr = this.dataList.filter(f => f[prop]);
            let otherArr = this.dataList.filter(f => !f[prop]);
            if (type === 'top') {
                this.sortActive = 'top';
                sortArr = listArr.sort((a, b) => a[prop].localeCompare(b[prop]));
            } else {
                this.sortActive = 'bottom';
                sortArr = listArr.sort((a, b) => b[prop].localeCompare(a[prop]));
            }
            this.dataList = [...sortArr, ...otherArr];
        },
        // 配件信息
        showAPMsgDialog(id) {
            let that = this;
            if (id) {
                this.EntpTempGoodsIdEdit = id;
                this.APMsgVisible = true;
            } else if (that.currentRow && that.currentRow.EntpTempGoodsId) {
                this.EntpTempGoodsIdEdit = that.currentRow.EntpTempGoodsId;
                this.APMsgVisible = true;
            }
        },
        closeAPMsgDialog(edit) {
            this.APMsgVisible = false;
            if (edit) {
                this.getOrderDetail();
            }
        },
        keyEvent(ev, code, row, index) {
            let that = this;
            if (ev.key == 'ArrowLeft') {
                if (code == 'CostPrice') {
                    if (that.$refs[`countRef`]) that.$refs[`countRef`].focus();
                }
            } else if (ev.key == 'ArrowRight') {
                if (code == 'Count') {
                    if (that.$refs[`priceRef`]) that.$refs[`priceRef`].focus();
                }
            }
        },
        // 自动选中输入框内容
        selectAutoHandle(ref) {
            clearTimeout(this.timer);
            //每次点击搜索配件后打开弹窗，select()事件没效果，有可能初始化控件后这个事件还没监听到input控件
            //所以这里用来nextTick 和 setTimeout做双重保证
            this.$nextTick(() => {
                this.timer = setTimeout(() => {
                    if (this.$refs[ref]) this.$refs[ref].select();
                }, 100);
            });
        },
        // 删除某行
        delItem(index) {
            if (this.dataList.length != 1) {
                if (this.recoverList.length > 0) {
                    var i = this.recoverList.find(e => e.EntpTempGoodsId == this.dataList[index].EntpTempGoodsId);
                    if (i != -1) {
                        this.recoverList.splice(i, 1);
                    }
                }
                this.dataList.splice(index, 1);
            }
            this.addPageChace();
            this.priceChange();
        },
        // 保存调仓单
        save(gotoAdd) {
            let that = this;
            let _list = that.dataList;
            if (!that.dataList[0]) {
                that.$util.warningMsg('请添加配件');
                return;
            }
            if (!that.submitData.OutWarehouseId) {
                this.$util.warningMsg('请选择调出仓库');
                return;
            }
            if (!that.submitData.InWarehouseId) {
                this.$util.warningMsg('请选择调入仓库');
                return;
            }
            for (let i = 0; i < _list.length; i++) {
                if (!_list[i].APCode) {
                    that.$util.warningMsg('请选择配件');
                    return;
                }

                if ((_list[i].Count - _list[i].WarehousedOutCount) > _list[i].OriginalCount) {
                    that.$util.warningMsg(`第【${i+1}】项${_list[i].GoodName}【${_list[i].APCode}】调出数量不得大于库存数量`);
                    return;
                }
            }
            if (that.saving) return;

            that.saving = true;
            that.submitData.DetailList = that.dataList;
            that.submitData.DetailList.forEach((e, i) => {
                e.SortNum = i + 1;
            });
            let url = '/api/EntpTransferOrder/NewSaveEnterpriseTransferOrder';
            if (that.type == 4) url = '/api/EntpTransferOrder/SaveTransferOrderAfterSubmit';
            that.needConfirm = false;
            that.$util
                .axiosPost({
                    url: url,
                    data: that.submitData
                })
                .then(res => {
                    if (that.type == 3) that.$util.successMsg('调拨单创建成功');
                    else that.$util.successMsg('调拨单保存成功');
                    that.$store.commit('updateNeedRefresh', true);
                    that.needConfirm = false;
                    that.removePageChace();
                    if (gotoAdd) {
                        setTimeout(() => {
                            that.reload();
                        }, 300);
                    } else {
                        setTimeout(() => {
                            that.$router.push('/inventoryManage/transWarehouse');
                        }, 1000);
                    }
                })
                .catch(() => {
                    that.saving = false;
                });
        },
        // 保存并添加调仓单
        saveAndAdd() {
            this.save(true);
        },
        //重新打开新增页面
        reload() {
            let that = this;
            that.getWarehouse();
            that.getWarehouseNotAuth();
            that.$router.push({ query: { type: 3, TOId: '' } });
            that.pageTitle = '新增调拨单';
            that.type = 3;
            that.dataList = [];
            that.recoverList = [];
            that.tableData = [];
            that.tableDataLength = 0;
            that.submitData = {
                ToId: '',
                OutWarehouseId: '',
                InWarehouseId: '',
                TranCost: 0,
                Remark: '',
                DetailList: []
            };
            that.saving = false;
            that.allNum = 0;
            that.allMoney = 0;
        },
        // 编辑&查看时获取列表
        getTableData() {
            this.loading = true;
            this.$util
                .axiosGet({
                    url: '/api/EntpTransferOrder/NewGetEntpTransOrderDetail',
                    data: {
                        TOId: this.submitData.TOId,
                        Type:this.type
                    }
                })
                .then(res => {
                    let data = res.data;
                    if (!data) data = {};
                    //这里这样做是为了防止select控件没有数据，现有绑定值，而导致页面展现出id
                    this.WarehouseList = [
                        {
                            WarehouseId: data.OutWarehouseId,
                            WarehouseName: data.OutWarehouseName
                        }
                    ];

                    this.WarehouseNotAuthList.push({
                        WarehouseId: data.InWarehouseId,
                        WarehouseName: data.InWarehouseName
                    });

                    this.submitData = data;
                    this.dataList = data.DetailList;
                    this.tranCost = data.TranCost;
                    this.orderState = data.State;
                    if (this.type == 1) {
                        this.dataReadonly = true;
                    }
                    this.priceChange();
                })
                .finally(() => {
                    this.loading = false;
                });
        },
        showNeedOutData(item) {
            if (item.EntpTempGoodsId && !this.needOutDataVisible) {
                this.EntpTempGoodsId = item.EntpTempGoodsId;
                this.NeedOTitle = '【配件待出数据】配件编码：' + item.APCode + ' —— 配件名称：' + item.GoodName;
                this.needOutDataVisible = true;
            } else if (item.EntpTempGoodsId && this.needOutDataVisible) {
                this.$refs.APNeedOutDatas.updateTableData(item.EntpTempGoodsId);
            }
        },
        showIntentDatas(id) {
            if (id) {
                if (this.inqHistoryVisible) {
                    this.$refs.APInquiryHistory.updateTableData(id);
                } else {
                    this.hisGoodsId = id;
                    this.inqHistoryVisible = true;
                }
            }
        },
        showNeedInData(item) {
            if (item.EntpTempGoodsId && !this.needInDataVisible) {
                this.EntpTempGoodsId = item.EntpTempGoodsId;
                this.NeedITitle = '【配件待入数据】配件编码：' + item.APCode + ' —— 配件名称：' + item.GoodName;
                this.needInDataVisible = true;
            } else if (item.EntpTempGoodsId && this.needInDataVisible) {
                this.$refs.APNeedInDatas.updateTableData(item.EntpTempGoodsId);
            }
        },
        //添加页面缓存
        addPageChace() {
            this.removePageChace();
            this.submitData.calcType = this.calcType;
            this.submitData.point = this.point;
            this.submitData.isCalcFirst = this.isCalcFirst;
            this.$util.setLocalStorage('transOrder', this.submitData);
            this.$util.setLocalStorage('transOrder_dataList', this.dataList);
            this.$util.setLocalStorage('transOrder_recoverList', this.recoverList);
        },
        //清除页面缓存
        removePageChace() {
            this.$util.clearLocalStorage('transOrder');
            this.$util.clearLocalStorage('transOrder_dataList');
            this.$util.clearLocalStorage('transOrder_recoverList');
        },
        //从缓存中读取数据
        getDataFromChace() {
            let salesOrderModel = this.$util.getLocalStorage('transOrder');
            let datalist = this.$util.getLocalStorage('transOrder_dataList');
            let recoverList = this.$util.getLocalStorage('transOrder_dataList');
            if (salesOrderModel) {
                this.calcType = salesOrderModel.calcType;
                this.point = salesOrderModel.point;
                this.isCalcFirst = salesOrderModel.isCalcFirst;
                this.submitData = salesOrderModel;
            }

            if (datalist && datalist.length > 0) {
                let _allNum = 0;
                let _allMoney = 0;
                for (let i = 0; i < datalist.length; i++) {
                    _allNum += Number(datalist[i].Count);
                    _allMoney += datalist[i].Count * datalist[i].CostPrice ? datalist[i].Count * datalist[i].CostPrice : 0;
                }
                this.allMoney = _allMoney;
                this.allNum = _allNum;
                this.dataList = datalist;
            }
            if (recoverList && recoverList.length > 0) {
                this.recoverList = recoverList;
            }
        },
        //销售历史
        showSaleHisDialog() {
            let that = this;
            if (that.currentRow && that.currentRow.EntpTempGoodsId&&that.submitData.InWarehouseId) {
                this.goodsId = that.currentRow.EntpTempGoodsId;
                this.saleHistory = true;
            }
        },
        //调入历史
        showTInHisDialog() {
            let that = this;
            if (that.currentRow && that.currentRow.EntpTempGoodsId&&that.submitData.InWarehouseId) {
                this.goodsId = that.currentRow.EntpTempGoodsId;
                this.inHisTitle=`调入历史-配件编码：${that.currentRow.APCode}  配件名称:${that.currentRow.GoodName}`
                this.tInHistory = true;
            }
        },
        //调出历史
        showTOutHisDialog() {
            let that = this;
            if (that.currentRow && that.currentRow.EntpTempGoodsId&&that.submitData.OutWarehouseId) {
                this.goodsId = that.currentRow.EntpTempGoodsId;
                this.outHisTitle=`调出历史-配件编码：${that.currentRow.APCode}  配件名称:${that.currentRow.GoodName}`
                this.tOutHistory = true;
            }
        },  
        closeHistoryDialog() {
            this.saleHistory = false;
            this.tInHistory=false;
            this.tOutHistory=false;
        },                                                
    }
};
</script>
<style lang="less" scoped>
.invens-summary {
    display: flex;
    flex-direction: row;
    height: 40px;
    line-height: 30px;
    padding: 0 20px;
    font-size: 14px;
    margin-left: -1px;
    border: 1px solid rgb(226, 226, 226);
    align-items: center;
    overflow-x: auto;
    overflow-y: hidden;
    white-space: nowrap;

    .title {
        font-size: 16px;
        font-weight: 600;
    }
    .summary-item {
        display: flex;
        flex-direction: row;

        .sname {
            font-size: 18px;
        }

        .scount {
            font-size: 20px;
            font-weight: 700px;
            color: #ea7060;
            margin-right: 20px;
        }
    }
}
.saleorder-v3 {
    padding: 10px 20px 0px 20px;
}

.tooltip-div {
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    word-break: break-all;
}

.s-btn,
.s-btn:focus,
.s-btn.is-active,
.s-btn.is-disabled:active,
.s-btn:active {
    padding: 3px;
    font-size: 15px;
    color: #fff;
    background: #ea7060;
    background-color: #ea7060;
    margin-right: 2px;
}

.s-btn.is-disabled:hover,
.s-btn:hover,
.s-btn.is-disabled {
    padding: 4px 4px;
    background: #f3bb53;
    background-color: #f3bb53;
    color: #fff;
}

.b-btn,
.b-btn:focus,
.b-btn.is-active,
.b-btn.is-disabled:active,
.b-btn:active {
    padding: 3px;
    font-size: 15px;
    color: #fff;
    background: #bac225;
    background-color: #bac225;
    margin-right: 2px;
}

.b-btn.is-disabled:hover,
.b-btn:hover,
.b-btn.is-disabled {
    padding: 4px 4px;
    background: #f3bb53;
    background-color: #f3bb53;
    color: #fff;
}

.payment-tip {
    position: absolute;
    left: 0;
    bottom: -18px;
    line-height: 1;
    font-size: 12px;
    color: @font4Color;
}
.section-title {
    display: flex;
    justify-content: space-between;
    height: 32px;
    line-height: 32px;
    padding: 0 20px;
    font-weight: bold;
    font-size: @font-sm;
    margin-left: -1px;
    background: @border3Color;
}

.edit-ctn {
    .div-table-cell {
        padding: 0 5px;
    }
}

.option-content {
    display: flex;
    line-height: 30px;

    .project-Name {
        width: 200px;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
        margin-right: 12px;
    }

    .project-iven {
        width: 50px;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
    }
}

.btn-ctn {
    padding: 30px 0;
    margin-right: 110px;
    text-align: right;
}

.add-btn {
    position: absolute;
    right: 2%;
    bottom: 0;
}

.less-btn {
    position: absolute;
    right: -40px;
    top: 2px;
    z-index: 2;
}

.table-main {
    position: relative;
}

.image-btn {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 60px;
    height: 60px;
    border: 1px dashed @border3Color;
}

.table-title {
    line-height: 36px;
    text-align: center;
    font-weight: bold;
}

.div-table-cell {
    display: flex;
    align-items: center;
    justify-content: center;
    text-overflow: ellipsis;
    overflow: hidden;
    white-space: nowrap;
    flex-grow: 1;
}

.table-item {
    height: 50px;
    position: relative;
}

.div-table-row {
    overflow: inherit;
    margin: -1px -1px -1px 0px;
}

.info-icon {
    vertical-align: top;
    margin-top: 2px;
    margin-right: 5px;
}

.special-border {
    height: 100%;
    border-radius: 3px;
    border: 1px solid #ffcc00;
}

.head-view {
    display: flex;
    justify-content: flex-start;
    align-items: center;

    .color-red {
        margin-right: 4px;
    }

    .sort-view {
        display: flex;
        flex-direction: column;

        i {
            line-height: 8px;
            cursor: pointer;
        }

        .active {
            color: #409eff;
        }
    }
}

.saveProgress {
    position: absolute;
    top: 38%;
    left: 45%;
    z-index: 99999;
}

.customer-view {
    display: flex;
    justify-content: flex-start;
    align-items: center;

    .grid-content {
        flex: 1;
    }

    .customer-checked {
        margin-left: 24px;
    }
}

.img-e-op {
    height: 32px;
    width: 32px;

    img {
        height: 28px;
        width: 28px;
        margin-bottom: 2px;
    }
}

.section-magin {
    margin-bottom: 5px;
}

.w100 {
    width: 100% !important;
}
.w60 {
    width: 60%;
}

.discount-zone {
    display: flex;
    flex-direction: row;
    justify-content: flex-start;
    align-items: center;
    line-height: 32px;
    height: 32px;

    .el-input-number {
        width: 110px;

        .el-input__inner {
            height: 32px;
        }
    }

    .el-select {
        margin-right: 12px;

        .el-input__inner {
            width: 110px;
            height: 32px;
            color: red;
        }

        .el-input__suffix {
            top: 4px;
        }

        .is-focus {
            .el-input__suffix {
                top: -4px;
            }
        }
    }
}

#search-dc-dialog,
#comfirm-ap-dialog {
    position: absolute;
    top: 0;
    left: 50%;
    right: auto;
    bottom: auto;
    width: 10px;
    height: 10px;
    overflow: visible;

    .el-dialog {
        box-shadow: 0 0 9px 3px #999;
    }

    .search-item-dialog {
        width: 340px;
        height: auto;

        .dialog-footer {
            text-align: right;
        }

        .el-form-item {
            margin-bottom: 0;
        }
    }

    .el-dialog__body {
        height: calc(100% - 54px);
        overflow: auto;
    }
}

#ap-image-dialog {
    position: absolute;
    top: auto;
    left: 0;
    right: auto;
    bottom: 400px;
    width: 10px;
    height: 10px;
    overflow: visible;

    .el-dialog {
        box-shadow: 0 0 9px 3px #999;
    }

    .image-item-dialog {
        width: 120px;
        height: 120px;
    }

    .el-dialog__body {
        padding: 0 !important;
        overflow: auto;
    }
}
.search-set-btn {
    margin-top: 4px;
    height: 24px;
    width: 25px;
    line-height: 24px;
    padding: 0;
    margin-right: 5px;
}
</style>

<style lang="less">
.order-infoes {
    border: 1px solid @border3Color;
    padding-top: 10px;
    margin-bottom: 10px;

    .grid-content {
        border-radius: 4px;
        min-height: 32px;
    }
    .el-form-item {
        margin-bottom: 0px;
        line-height: 32px;
        height: 32px;
    }

    .el-form-item__label {
        line-height: 32px;
        height: 32px;
    }

    .el-form-item__content {
        line-height: 32px !important;
        height: 32px;
        top: -1px;
    }
}

.pop-cls {
    font-size: 18px;
    padding: 10px 12px;
    color: #fff;
    background-color: #303133;

    .popper__arrow {
        color: #303133;
    }
}

#search-dialog {
    .el-dialog {
        box-shadow: 0 0 9px 3px #999;
    }

    .el-dialog__body {
        overflow: auto;
    }
}

#search-dialog::-webkit-scrollbar {
    display: none;
}

.check-code-class {
    .el-input__inner {
        border: 1px solid #f56c6c;
    }
}

.loseMoneyWarning {
    .el-input__inner {
        border: 1px solid #e6a23c;
    }
}

.el-col {
    border-radius: 4px;
}

.bg-purple-dark {
    background: #99a9bf;
}

.bg-purple {
    background: #d3dce6;
}

.bg-purple-light {
    background: #e5e9f2;
}

.row-bg {
    padding: 10px 0;
    background-color: #f9fafc;
}

.el-row {
    margin-bottom: 10px !important;

    &:last-child {
        margin-bottom: 10px !important;
    }
}

.search-in-order {
    .elx-table {
        .elx-body--row.row--hover,
        .elx-body--row.row--hover.row--stripe {
            background-color: #dcdee1;
        }

        .elx-table--header-wrapper {
            .elx-header--row {
                .elx-header--column {
                    height: 34px;
                }

                .elx-cell {
                    padding: 4px 12px 0;
                }
            }
        }

        .elx-table--body-wrapper {
            .elx-body--row {
                .table-sort {
                    .elx-cell {
                        padding: 4px 12px 0;
                    }
                }

                td {
                    height: 26px;
                    line-height: 26px;
                }
            }

            .elx-cell {
                height: 26px;
                padding-left: 10px;
                padding-right: 10px;
            }
        }

        .elx-table--footer-wrapper {
            margin-top: 0 !important;
        }
    }
}

.sales-order-edit {
    .elx-table {
        .elx-body--row.row--hover,
        .elx-body--row.row--hover.row--stripe {
            background-color: #dcdee1;
        }

        .elx-table--header-wrapper {
            .elx-header--row {
                .elx-header--column {
                    height: 34px;
                }

                .elx-cell {
                    padding: 4px 12px 0;
                }
            }
        }

        .elx-table--body-wrapper {
            .elx-body--row {
                .table-sort {
                    .elx-cell {
                        padding: 4px 12px 0;
                    }
                }

                .div-padding-12 {
                    padding: 4px 8px 0;
                }

                .div-margin-op {
                    display: flex;
                    flex-direction: row;
                    align-items: center;
                }

                .operate {
                    padding: 0 12px;
                }

                td {
                    height: 26px;
                }
            }

            .elx-cell {
                padding: 0;
                height: 32px;
            }

            .el-button--small {
                padding: 5px 15px;
                margin: 3px 9px 0 0;
            }
        }

        .elx-table--footer-wrapper {
            margin-top: 0 !important;
        }

        .elx-table--body-wrapper {
            padding-bottom: 180px !important;
        }

        // .elx-table--body tr.row--current > td {
        //   background: rgb(206, 206, 206) !important;
        // }
    }

    .sales-input-cell {
        .el-input-number {
            width: 100%;
        }

        .el-input {
            .el-input__inner {
                padding-left: 0;
                padding-right: 20px;
            }
        }

        .el-input-number__decrease,
        .el-input-number__increase {
            width: 20px;
        }
    }

    .salecounts-input-cell {
        .el-input-number {
            width: 100%;
        }

        .el-input {
            .el-input__inner {
                padding-left: 0;
                padding-right: 20px;
            }
        }

        .el-input-number__decrease,
        .el-input-number__increase {
            width: 20px;
        }
    }

    .unit-input-cell {
        .el-input {
            .el-input__inner {
                padding-right: 20px;
            }
        }
    }

    .sales-apcode {
        .el-tag {
            height: 24px;
            line-height: 22px;
            margin-left: 8px;
        }

        .sp-i {
            height: 24px;
            margin-left: -6px;
            margin-right: 2px;
        }
        .el-icon-info {
            color: #87a7d6;
            font-size: 18px;
            vertical-align: top;
            cursor: pointer;
            margin-top: 2px;
        }
    }
}
.apcode_msgCls {
    position: absolute;
    top: auto !important;
    bottom: 130px;
    height: 30px;

    .el-message__icon {
        display: none;
    }

    .el-message__content {
        font-size: 24px;
    }
}
</style>
